import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  Paper,
  TextField,
  Typography,
  Divider,
  InputAdornment,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { Info, Edit, ArrowForwardIos, ChevronLeft, CheckCircle as CheckCircleIcon, Delete as DeleteIcon, Add as AddIcon, Warning as WarningIcon, Close as CloseIcon } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import {DatePicker} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import IconButton from "@material-ui/core/IconButton";
import Event from "@material-ui/icons/Event";
import { PDFViewer } from "../../sasl/batch/updateBatch/StructuredInformation/PDFViewer";
import { appUrl } from "../../../../../../utils/config";
import { getFeaturesAccess } from "../../../../containers/actions/common/accessControl";

// Styling
const useStyles = makeStyles((theme) => ({
  body : {
    overflow: "hidden",
  },
  formLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minWidth: "150px",
    paddingRight: theme.spacing(2),
    textAlign: "right",
  },
  fixedLabel: {
    width: 180,
    textAlign: "left",
    paddingRight: theme.spacing(2),
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
  sectionTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  testTable: {
    '& .MuiTableCell-head': {
      backgroundColor: '#f5f5f5',
      fontWeight: 'bold',
    },
  },
  FeildHistoryHorizantalBorder: {
    borderBottom: "1px solid grey"
  },
  closeText: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 600,
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    cursor: "pointer",
    padding: "0.3rem",
  },
}));

// Function to convert snake_case to Title Case, if cmo or bms word is present, then return the word in uppercase
const toTitleCase = (str) => {
  // Check the full string first for special cases
  const lowerStr = str.toLowerCase();
  if (lowerStr === "total_weight") {
    return "Produced Quantity";
  } else if (lowerStr === "quantity_produced") {
    return "Quantity";
  }
  
  // Then process word by word
  return str
    .split("_")
    .map((word) => {
      const lowerWord = word.toLowerCase();
      if (lowerWord === "cmo") {
        return "CMO";
      } else if (lowerWord === "bms") {
        return "Amgen";
      } else if (lowerWord === "sponsor") {
        return "Amgen";
      } else if (lowerWord === "uom") {
        return "UoM";
      } else if (lowerWord === "of") {
        return "of";
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
    })
    .join(" ");
};

const convertToISOUTC = (dateInput) => {
  let date;

  if (
    dateInput === null ||
    dateInput === "N/A" ||
    dateInput === "n/a" ||
    dateInput === "NA"
  ) {
    return "";
  }

  try {
    // Handle different input types
    if (dateInput instanceof Date) {
      date = dateInput;
    } else if (typeof dateInput === "number") {
      // Unix timestamp (seconds or milliseconds)
      date = new Date(dateInput < 10000000000 ? dateInput * 1000 : dateInput);
    } else if (typeof dateInput === "string") {
      // Handle various string formats
      date = parseStringDate(dateInput);
    } else {
      return null; // Invalid input type
    }

    // Validate the date
    if (isNaN(date.getTime())) {
      return null; // Invalid date
    }

    // For date-only fields, preserve the date without timezone conversion
    // Format as YYYY-MM-DD to avoid timezone issues
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (error) {
    return null; // Any parsing error
  }
};

const parseStringDate = (dateString) => {
  // Clean the input
  const cleanInput = dateString.trim();

  // Check for obviously invalid patterns that should be rejected
  const invalidPatterns = [
    /[{}[\]]/, // Contains braces or brackets
    /[!@#$%^&*()+=<>?~`]/, // Contains special characters (excluding common date separators)
    /\d{5,}/, // Contains numbers with 5+ consecutive digits (except for years in valid positions)
  ];

  // Reject strings with invalid characters
  const hasInvalidPattern = invalidPatterns.some((pattern) =>
    pattern.test(cleanInput)
  );
  if (hasInvalidPattern) {
    // Exception: allow valid year formats even if they contain 4+ digits
    const validYearPattern =
      /^\d{1,2}[\/\-\.]\d{1,2}[\/\-\.]\d{4}$|^\d{4}[\/\-\.]\d{1,2}[\/\-\.]\d{1,2}$|^\d{1,2}\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+\d{4}$/i;
    if (!validYearPattern.test(cleanInput)) {
      throw new Error(`Invalid characters in date format: ${dateString}`);
    }
  }

  // Try native Date parsing first
  let date = new Date(cleanInput);
  if (!isNaN(date.getTime())) {
    return date;
  }

  // Handle DD/MM/YYYY vs MM/DD/YYYY ambiguity
  // Assume MM/DD/YYYY for US-style dates unless day > 12
  const slashMatch = cleanInput.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (slashMatch) {
    const [, first, second, year] = slashMatch;
    const firstNum = parseInt(first);
    const secondNum = parseInt(second);

    // If first number > 12, assume DD/MM/YYYY
    if (firstNum > 12) {
      const reformatted = cleanInput.replace(
        /^(\d{1,2})\/(\d{1,2})\/(\d{4})/,
        `$2/$1/$3`
      );
      date = new Date(reformatted);
      if (!isNaN(date.getTime())) {
        return date;
      }
    }
  }

  // Handle dot notation (European style DD.MM.YYYY)
  const dotMatch = cleanInput.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/);
  if (dotMatch) {
    const [, day, month, year] = dotMatch;
    const reformatted = cleanInput.replace(
      /^(\d{1,2})\.(\d{1,2})\.(\d{4})/,
      `$2/$1/$3`
    );
    date = new Date(reformatted);
    if (!isNaN(date.getTime())) {
      return date;
    }
  }

  // If all else fails, throw an error (will be caught by try-catch in main function)
  throw new Error(`Unable to parse date format: ${dateString}`);
};

const CommonDigitizedDocument = (props) => {
  // State to track file type (pdf or excel)
  const [fileType, setFileType] = useState(null);

  // Handler for file type changes from PDFViewer component
  const handleFileTypeChange = (type) => {
    setFileType(type);
  };
  const {
    initialData,
    onClose,
    handleCloseRef,
    schrockenCustomFileID,
    digitizedData,
    batchDetails,
    poNumber,
    batchNumber,
    cmoBatchNumber,
    onDataRefresh,
  } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const docType = digitizedData?.documentType || "Unknown";

  // Get screen access for fgBatch
  const screenAccess = useSelector((state) => {
    return state.pcmp.common.accessControl.screensAccess.data.fgBatch;
  });

  // Get features access for fgBatch
  const featuresAccess = useSelector((state) => {
    return state.pcmp.common.accessControl.featuresAccess.fgBatch;
  });

   // Call getFeaturesAccess when component mounts
   useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess) {
      dispatch(getFeaturesAccess(screenAccess?.screenId, "fgBatch"));
    }
    // Mark as loaded when featuresAccess is available or when it's CMO (doesn't need it)
    if (featuresAccess || localStorage.collabType === "CMO") {
      setIsFeaturesAccessLoaded(true);
    }
  }, [dispatch, screenAccess, featuresAccess]);

  //console.log("here is the featuresAccess",featuresAccess);
  //console.log("here is the screenAccess",screenAccess);

  // const deliverySchedulesFeatures = useSelector(
  //    (state) =>
  //      state.pcmp.common.accessControl.featuresAccess?.deliverySchedulesFeatures
  // );
  // const canReviewAndEdit = !deliverySchedulesFeatures?.ReviewandEditFields;
  const canReviewAndEdit=()=>
  {
    if(localStorage.collabType !== "CMO")
    {
      //console.log("here is the featuresAccess",featuresAccess?.ReviewandEditFields);
      return featuresAccess?.ReviewandEditFields;
    }
    return false;
  }

  // Helper to get original data from extractedData
  const getDocumentFromExtractedData = () => {
    if (batchDetails?.digitizedExtractedData) {
      if (Array.isArray(batchDetails.digitizedExtractedData)) {
        const document = batchDetails.digitizedExtractedData.find(
          (doc) => doc.kvpJsonOriginal?.document_type === docType
        );
        return document?.kvpJsonOriginal || null;
      } else if (
        batchDetails.digitizedExtractedData.kvpJsonOriginal?.document_type ===
        docType
      ) {
        return batchDetails.digitizedExtractedData.kvpJsonOriginal || null;
      }
    }
    return null;
  };

  // Helper to check if edited data exists and has content
  const hasEditedData = () => {
    if (batchDetails?.digitizedExtractedData) {
      if (Array.isArray(batchDetails.digitizedExtractedData)) {
        const document = batchDetails.digitizedExtractedData.find(
          (doc) => doc.kvpJsonOriginal?.document_type === docType
        );
        return (
          document?.kvpJsonEdited &&
          Object.keys(document.kvpJsonEdited).length > 0
        );
      } else if (
        batchDetails.digitizedExtractedData.kvpJsonOriginal?.document_type ===
        docType
      ) {
        return (
          batchDetails.digitizedExtractedData.kvpJsonEdited &&
          Object.keys(batchDetails.digitizedExtractedData.kvpJsonEdited)
            .length > 0
        );
      }
    }
    return false;
  };

  const [apiData, setApiData] = useState(initialData || {});
  const [originalData, setOriginalData] = useState(initialData || {});
  const [editedData, setEditedData] = useState(initialData || {});
  const [showingOriginal, setShowingOriginal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [editModalValidationError, setEditModalValidationError] = useState("");
  const [markReviewValidationErrors, setMarkReviewValidationErrors] = useState([]);
  const [saving, setSaving] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [isFetchingHistory, setIsFetchingHistory] = useState(false);
  const [enableAllFieldsEdit, setEnableAllFieldsEdit] = useState(false);
  const [modalData, setModalData] = useState({
    field: "",
    historyData: [],
    hasHistory: false,
  });
  const [editModalData, setEditModalData] = useState({
    fieldKey: "",
    fieldLabel: "",
    currentValue: "",
    saveValue: "",
    originalValue: "",
    confidenceLevel: 0,
    dataType: "",
    digitalizationCode: "",
    comment: "",
  });
  const [apiDigitalizationCodes, setApiDigitalizationCodes] = useState([]);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [successDialogTitle, setSuccessDialogTitle] = useState("");
  const [markingReviewComplete, setMarkingReviewComplete] = useState(false);
  const [showExitWarning, setShowExitWarning] = useState(false);
  const [productCode, setProductCode] = useState(null);
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [deleteConfirmData, setDeleteConfirmData] = useState({
    type: "", // "batch" or "consumptionSection"
    bowlIndex: null,
    rowIndex: null,
    batchNumber: null,
    consumptionDetailsLabel: "",
    materialNumber: "",
    batchNumberValue: "",
    quantity: "",
  });
  const [deleteError, setDeleteError] = useState("");
  const [showMaterialNumberError, setShowMaterialNumberError] = useState(false);
  const [isFeaturesAccessLoaded, setIsFeaturesAccessLoaded] = useState(false);

  // Nested value helpers
  const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split(".").reduce((current, key) => {
      if (current === null || current === undefined) {
        return undefined;
      }
      if (key.includes("[")) {
        const [arr, idx] = key.split("[");
        const arrayIndex = parseInt(idx.replace("]", ""));
        if (current[arr] && Array.isArray(current[arr]) && current[arr][arrayIndex] !== undefined) {
          return current[arr][arrayIndex];
        }
        return undefined;
      }
      return current[key];
    }, obj);
  };

  const setNestedValue = (obj, path, value) => {
    if (!obj || !path) return;
    const parts = path.split(".");
    const lastKey = parts.pop();
    const target = parts.reduce((current, key) => {
      if (current === null || current === undefined) {
        return undefined;
      }
      if (key.includes("[")) {
        const [arr, idx] = key.split("[");
        const arrayIndex = parseInt(idx.replace("]", ""));
        if (current[arr] && Array.isArray(current[arr]) && current[arr][arrayIndex] !== undefined) {
          return current[arr][arrayIndex];
        }
        return undefined;
      }
      return current[key];
    }, obj);
    if (target !== null && target !== undefined) {
      target[lastKey] = value;
    }
  };

  const parseFieldPath = (path, data) => {

    
    const bowlsMatch = path.match(/bowls\[(\d+)\]\.rows\[(\d+)\]\.(.+)/);
    if (bowlsMatch) {
      const [, bowlIndex, rowIndex, fieldKey] = bowlsMatch;
      const bowl = data.bowls?.[parseInt(bowlIndex)];
      return {
        dataFieldName: fieldKey,
        ID: bowl?.ID ?? null, // Use null if ID is undefined
        rowID: bowl?.rows?.[parseInt(rowIndex)]?.row_id ?? null, // Use null if row_id is undefined
      };
    }

    // Handle pallets structure: pallets[index].fieldKey
    const palletsMatch = path.match(/pallets\[(\d+)\]\.(.+)/);
    if (palletsMatch) {
      const [, palletIndex, fieldKey] = palletsMatch;
      const pallet = data.pallets?.[parseInt(palletIndex)];
      return {
        dataFieldName: fieldKey,
        ID: null,
        rowID: pallet?.row_id ?? null,
      };
    }
    
   
    
    return { dataFieldName: path, ID: null, rowID: null };
  };

  // Helper function to merge incoming data while preserving reasonCode and comment from existing edits
  // This prevents info icons from flipping back to confidence levels when data refreshes
  const mergePreservingEdits = (currentData, incomingData) => {
    if (!currentData || !incomingData) return incomingData;
    
    const merged = JSON.parse(JSON.stringify(incomingData)); // Deep clone incoming data

    
    // Preserve counts from current data if they are higher than incoming data
    // This prevents counts from resetting when backend hasn't updated yet
    const currentToBeReviewed = currentData.noOfFieldsToBeReviewed || 0;
    const currentReviewed = currentData.noOfFieldsReviewed || 0;
    const incomingToBeReviewed = merged.noOfFieldsToBeReviewed || 0;
    const incomingReviewed = merged.noOfFieldsReviewed || 0;
    
    // If current reviewed count is higher, preserve it (means local edit not yet reflected in backend)
    if (currentReviewed > incomingReviewed) {
      merged.noOfFieldsReviewed = currentReviewed;
      merged.noOfFieldsToBeReviewed = currentToBeReviewed;
    }
    
    // Merge regular fields
    Object.keys(merged).forEach((key) => {
      if (key !== "bowls" && typeof merged[key] === "object" && merged[key] !== null && "value" in merged[key]) {
        const currentField = currentData[key];
        if (currentField && typeof currentField === "object") {
          // Preserve reasonCode and comment from current data if they exist
          if (currentField.reasonCode && !merged[key].reasonCode) {
            merged[key].reasonCode = currentField.reasonCode;
          }
          if (currentField.comment && !merged[key].comment) {
            merged[key].comment = currentField.comment;
          }
          // If field was marked as not needing validation (edited), preserve that
          if (currentField.needValidation === false && merged[key].needValidation === true) {
            merged[key].needValidation = false;
          }
        }
      }
    });
    
    // Merge bowls fields
    if (merged.bowls && Array.isArray(merged.bowls) && currentData.bowls && Array.isArray(currentData.bowls)) {
      merged.bowls.forEach((bowl, bowlIndex) => {
        const currentBowl = currentData.bowls[bowlIndex];
        if (bowl.rows && Array.isArray(bowl.rows) && currentBowl?.rows && Array.isArray(currentBowl.rows)) {
          bowl.rows.forEach((row, rowIndex) => {
            const currentRow = currentBowl.rows[rowIndex];
            if (currentRow) {
              Object.keys(row).forEach((fieldKey) => {
                if (fieldKey !== "row_id" && typeof row[fieldKey] === "object" && row[fieldKey] !== null && "value" in row[fieldKey]) {
                  const currentField = currentRow[fieldKey];
                  if (currentField && typeof currentField === "object") {
                    // Preserve reasonCode and comment from current data if they exist
                    if (currentField.reasonCode && !row[fieldKey].reasonCode) {
                      row[fieldKey].reasonCode = currentField.reasonCode;
                    }
                    if (currentField.comment && !row[fieldKey].comment) {
                      row[fieldKey].comment = currentField.comment;
                    }
                    // If field was marked as not needing validation (edited), preserve that
                    if (currentField.needValidation === false && row[fieldKey].needValidation === true) {
                      row[fieldKey].needValidation = false;
                    }
                  }
                }
              });
            }
          });
        }
      });
    }
    
    return merged;
  };

  // Dynamic data initialization
  useEffect(() => {
    let dataToUse = initialData || {};
    let originalDataToUse = initialData || {};

    if (batchDetails?.digitizedExtractedData) {
      let document;
      const currentFileID = schrockenCustomFileID;
      
      if (Array.isArray(batchDetails.digitizedExtractedData)) {
        if (currentFileID) {
          document = batchDetails.digitizedExtractedData.find(
            (doc) => doc.schrockenCustomFileID === currentFileID
          );
        }
        
        if (!document) {
          document = batchDetails.digitizedExtractedData.find(
            (doc) => doc.kvpJsonOriginal?.document_type === docType ||
                     doc.kvpJsonEdited?.document_type === docType
          );
        }
      } else if (
        batchDetails.digitizedExtractedData.kvpJsonOriginal?.document_type === docType ||
        batchDetails.digitizedExtractedData.kvpJsonEdited?.document_type === docType
      ) {
        document = batchDetails.digitizedExtractedData;
      }

      if (document) {
        if (
          document.kvpJsonEdited &&
          Object.keys(document.kvpJsonEdited).length > 0
        ) {
          dataToUse = document.kvpJsonEdited;
          originalDataToUse = document.kvpJsonOriginal || document.kvpJsonEdited;
          
          // Preserve markAsReviewed from kvpJsonOriginal if not in kvpJsonEdited
          if (document.kvpJsonOriginal?.markAsReviewed !== undefined && dataToUse.markAsReviewed === undefined) {
            dataToUse.markAsReviewed = document.kvpJsonOriginal.markAsReviewed;
          }
        } else if (document.kvpJsonOriginal) {
          dataToUse = document.kvpJsonOriginal;
          originalDataToUse = document.kvpJsonOriginal;
        }
      }
    }

    // Merge with existing apiData to preserve reasonCode and comment from local edits
    // This prevents info icons from disappearing when data refreshes after 2-3 minutes
    const mergedData = mergePreservingEdits(apiData, dataToUse);
    setApiData(mergedData);
    setOriginalData(originalDataToUse);
    setEditedData(mergedData);
  }, [initialData, batchDetails, docType, schrockenCustomFileID]);

  useEffect(() => {
    const isDocumentMarkedAsReviewed = apiData.markAsReviewed === true;
    const hasNoPartialShipping = !batchDetails?.partialShippingDetails || batchDetails?.partialShippingDetails?.length === 0;
    
    // Get document category for additional checks
    const customFile = batchDetails?.customFilesList?.find(
      file => file.schrockenCustomFileID === schrockenCustomFileID?.toString()
    );
    const category = customFile?.documentCategoryType;
    
    // Enable editing if document is marked as reviewed and no partial shipping
    if (isDocumentMarkedAsReviewed && hasNoPartialShipping) {
      setEnableAllFieldsEdit(true)
    }
    // Enable editing for Post-Shipment Documents docs when reviewPostShipmentFieldsReqd is true and partialShippingDetails exists
    else if (batchDetails?.reviewPostShipmentFieldsReqd === true && 
             batchDetails?.partialShippingDetails && 
             batchDetails.partialShippingDetails.length > 0 && 
             category === "Post-Shipment Documents") {
      setEnableAllFieldsEdit(true)
    }
  }, []);

  // Handle refresh when batchDetails changes
  useEffect(() => {
    if (
      batchDetails &&
      !showingOriginal &&
      batchDetails.digitizedExtractedData
    ) {
      let document;
      const currentFileID = schrockenCustomFileID;
      
      if (Array.isArray(batchDetails.digitizedExtractedData)) {
        if (currentFileID) {
          document = batchDetails.digitizedExtractedData.find(
            (doc) => doc.schrockenCustomFileID === currentFileID
          );
        }
        
        if (!document) {
          document = batchDetails.digitizedExtractedData.find(
            (doc) => doc.kvpJsonOriginal?.document_type === docType ||
                     doc.kvpJsonEdited?.document_type === docType
          );
        }
      } else if (
        batchDetails.digitizedExtractedData.kvpJsonOriginal?.document_type === docType ||
        batchDetails.digitizedExtractedData.kvpJsonEdited?.document_type === docType
      ) {
        document = batchDetails.digitizedExtractedData;
      }

      if (
        document &&
        document.kvpJsonEdited &&
        Object.keys(document.kvpJsonEdited).length > 0
      ) {
        // Merge with existing apiData to preserve reasonCode and comment from local edits
        const mergedData = mergePreservingEdits(apiData, document.kvpJsonEdited);
        setApiData(mergedData);
        setEditedData(mergedData);
      } else if (document && document.kvpJsonOriginal) {
        setApiData(document.kvpJsonOriginal);
        setEditedData(document.kvpJsonOriginal);
      }
    }
  }, [batchDetails, showingOriginal, docType, schrockenCustomFileID]);

  // Fetch digitalization codes
  useEffect(() => {
    const fetchDigitalizationCodes = async () => {
      try {
        const response = await axios.get(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/Admin/fetchDigitalizationCodes`
        );
        if (response.data.status && response.data.digitalizationCodesList) {
          const activatedCodes = response.data.digitalizationCodesList
            .filter((code) => code.activated && !code.markForDelete)
            .map((code) => ({
              code: code.digitalizationCode,
              description: code.digitalizationCodeDescription,
            }));
          setApiDigitalizationCodes(activatedCodes);
        }
      } catch (error) {
        console.error("Error fetching digitalization codes:", error);
      }
    };
    fetchDigitalizationCodes();
  }, []);

  // Validate field
  const validateField = (fieldKey, value) => {
    if (!value || value.trim() === "") {
      return `${toTitleCase(fieldKey)} is required`;
    }
    return null;
  };

  // Format date for display - normalize all date formats to DD-MMM-YYYY
  const formatDateForDisplay = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "n/a" || dateString === "NA") {
      return dateString || "";
    }

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    try {
      let parsedDate = null;

      // Pattern 1: YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss format (ISO)
      const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        const [, year, month, day] = isoMatch;
        return `${parseInt(day)}-${monthNames[parseInt(month) - 1]}-${year}`;
      }

      // Pattern 2: DD-MMM-YYYY (already in target format)
      if (/^\d{1,2}-[A-Za-z]{3}-\d{4}$/.test(dateString)) {
        return dateString;
      }

      // Pattern 3: DD.MMM.YYYY (e.g., "31.Dec.2025")
      const dotMonthMatch = dateString.match(/^(\d{1,2})\.([A-Za-z]{3})\.(\d{4})$/);
      if (dotMonthMatch) {
        const [, day, month, year] = dotMonthMatch;
        return `${parseInt(day)}-${month}-${year}`;
      }

      // Pattern 4: MM/DD/YYYY or DD/MM/YYYY
      const slashMatch = dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (slashMatch) {
        const [, first, second, year] = slashMatch;
        // Try to parse using Date object
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          const day = date.getDate();
          const month = date.getMonth();
          return `${day}-${monthNames[month]}-${year}`;
        }
      }

      // Fallback: Try to parse with Date object for any other format
      const date = parseStringDate(dateString);
      if (date && !isNaN(date.getTime())) {
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();
        return `${day}-${monthNames[month]}-${year}`;
      }
    } catch (error) {
      console.error("Error formatting date:", error);
    }

    // If all parsing fails, return original
    return dateString;
  };

  // Get field value
  const getValueForField = (path) => {
    const data = showingOriginal ? originalData : apiData;
    const fieldData = getNestedValue(data, path);
    const value = fieldData &&
      typeof fieldData === "object" &&
      fieldData.value !== undefined
      ? fieldData.value || ""
      : fieldData || "";

    // Format date values for display
    if (fieldData && typeof fieldData === "object" && fieldData.dataType === "Date" && value) {
      return formatDateForDisplay(value);
    }

    return value;
  };

  // Get confidence for field
  const getConfidenceForField = (path) => {
    const data = showingOriginal ? originalData : apiData;
    const fieldData = getNestedValue(data, path);
    if (
      fieldData &&
      typeof fieldData === "object" &&
      fieldData.confidence != null
    ) {
      return parseFloat(fieldData.confidence);
    }
    return 0;
  };

  // Get color for confidence level
  const getLevelColor = (level) => {
    if (level === null || level === undefined) return "#cccccc";
    const confidenceLevels = batchDetails?.confidenceLevels || {
      lowConfidenceLimit: 80,
      highConfidenceLimit: 90,
    };
    const lowConfidenceLimit = confidenceLevels.lowConfidenceLimit;
    const highConfidenceLimit = confidenceLevels.highConfidenceLimit;
    if (level < lowConfidenceLimit) return "red";
    if (level <= highConfidenceLimit) return "orange";
    return "green";
  };

  // Get confidence display
  const getConfidenceDisplay = (path) => {
    const confidence = getConfidenceForField(path);
    return confidence !== null ? Math.round(confidence) : "0";
  };

  // Get dataType for field
  const getDataTypeForField = (path) => {
    const data = showingOriginal ? originalData : apiData;
    const fieldData = getNestedValue(data, path);
    if (fieldData && typeof fieldData === "object" && fieldData.dataType) {
      return fieldData.dataType;
    }
    return null;
  };

  // Check if field is mandatory
  const isFieldMandatory = (path) => {
    try {
      const data = showingOriginal ? originalData : apiData;
      
      // For fields in bowls (consumption details), check if the row or bowl is new
      const bowlsMatch = path.match(/bowls\[(\d+)\]\.rows\[(\d+)\]\.(.+)/);
      if (bowlsMatch) {
        const [, bowlIndex, rowIndex, fieldKey] = bowlsMatch;
        const bowl = data.bowls?.[parseInt(bowlIndex)];
        const row = bowl?.rows?.[parseInt(rowIndex)];
        const isBowlNew = bowl?.isNew === true;
        const isRowNew = row?.isNew === true;
        
        // Fields that should show mandatory indicator even in new bowls (new consumed material)
        const mandatoryFieldsForNewBowls = [
          'consumption_batch_number_sponsor',
          'consumption_batch_number',
          'actual_material_quantity_consumed'
        ];
        
        // If bowl is new (new consumed material), only show mandatory for specific fields
        if (isBowlNew && !mandatoryFieldsForNewBowls.includes(fieldKey)) {
          return false;
        }
        
        // If row is new but bowl is NOT new (new consumed batch in existing bowl), 
        // show mandatory for ALL fields that have isMandatory set to true
        if (isRowNew && !isBowlNew) {
          const fieldData = getNestedValue(data, path);
          return !!(fieldData && typeof fieldData === "object" && fieldData.isMandatory === true);
        }
      }
      
      const fieldData = getNestedValue(data, path);
      return !!(fieldData && typeof fieldData === "object" && fieldData.isMandatory === true);
    } catch (e) {
      // If path traversal fails or data is missing, treat as not mandatory rather than crashing render
      return false;
    }
  };

  // Check if field should show info icon
  const shouldShowInfoIcon = (path) => {
    if (showingOriginal) return false;
    const fieldData = getNestedValue(apiData, path);
    return (
      fieldData &&
      typeof fieldData === "object" &&
      // fieldData.needValidation === false &&
      (fieldData.reasonCode || fieldData.comment)
    );
  };

  // Check if field needs validation
  const shouldShowEditForValidation = (path) => {
    if (showingOriginal) return false;
    const fieldData = getNestedValue(apiData, path);
    return (
      fieldData &&
      typeof fieldData === "object" &&
      fieldData.needValidation === true
    );
  };

  // Check if editing is allowed based on document category
  const isDocumentCategoryEditable = () => {
    // return true
    if (!batchDetails || !schrockenCustomFileID) return false;
    
    // Get document category first
    const customFile = batchDetails.customFilesList?.find(
      file => file.schrockenCustomFileID === schrockenCustomFileID.toString()
    );
    
    if (!customFile) return false;
    
    const category = customFile.documentCategoryType;
    
    // If all review flags are false, allow editing only for Post-Manufacturing and Pre-Shipment Documents
    if ((!(batchDetails.reviewPostMFGFieldsReqd) || (batchDetails.reviewPostMFGFieldsReqd === false)) && 
        (!(batchDetails?.partialShippingDetails) || (batchDetails?.partialShippingDetails.length === 0)) && 
        (!(batchDetails.reviewPreShipmentFieldsReqd) || (batchDetails.reviewPreShipmentFieldsReqd === false)) ) {
      if (category === "Post-Manufacturing" || category === "Pre-Shipment Documents") {
        return true;
      }
      return false;
    }
    
    
    // Special case: if reviewPostMFGFieldsReqd is null/false and reviewPreShipmentFieldsReqd is true,
    // allow editing for both Post-Manufacturing and Pre-Shipment Documents
    if ((!(batchDetails.reviewPostMFGFieldsReqd) || (batchDetails.reviewPostMFGFieldsReqd === false)) && 
        (batchDetails.reviewPreShipmentFieldsReqd === true)) {
      if (category === "Post-Manufacturing" || category === "Pre-Shipment Documents") {
        return true;
      }
    }
    
    // Special case: when reviewPostShipmentFieldsReqd is true and partialShippingDetails array has items,
    // allow editing for Post-Shipment Documents documents
    if (batchDetails.reviewPostShipmentFieldsReqd === true && 
        batchDetails?.partialShippingDetails && 
        batchDetails.partialShippingDetails.length > 0 && 
        category === "Post-Shipment Documents") {
      return true;
    }
    
    // Map review flags to their corresponding categories
    if (category === "Post-Manufacturing" && batchDetails.reviewPostMFGFieldsReqd === true) {
      return true;
    }
    if (category === "Post-Shipment Documents" && batchDetails.reviewPostShipmentFieldsReqd === true) {
      return true;
    }
    if (category === "Pre-Shipment Documents" && batchDetails.reviewPreShipmentFieldsReqd === true) {
      return true;
    }
    
    return false;
  };

  // // Input validation based on dataType
  // const validateInput = (value, dataType) => {
  //   if (!dataType) return true; // If no dataType specified, allow any input

  //   switch (dataType) {
  //     case "Number":
  //       return /^-?\d*\.?\d*$/.test(value) && value !== "";
  //     case "String":
  //       return /^[a-zA-Z0-9\s]*$/.test(value); // Only alphanumeric and spaces
  //     case "Date":
  //       return true; // Date picker will handle validation
  //     default:
  //       return true;
  //   }
  // };

  // const formatInputValue = (value, dataType) => {
  //   if (!dataType) return value; // If no dataType specified, return as is

  //   if (dataType === "Number") {
  //     // Remove any non-numeric characters except decimal point and minus
  //     return value.replace(/[^-0-9.]/g, "");
  //   }
  //   if (dataType === "String") {
  //     // Remove special characters except spaces
  //     return value.replace(/[^a-zA-Z0-9\s]/g, "");
  //   }
  //   return value;
  // };

  // Handle input restriction based on dataType
  const handleInputRestriction = (e, dataType) => {
    const value = e.target.value;

    if (dataType === "Numeric") {
      // Allow only numbers, decimal point.
      e.target.value = value.replace(/[^0-9.]/g, "");

      // Prevent multiple decimal points
      const parts = e.target.value.split(".");
      if (parts.length > 2) {
        e.target.value = parts[0] + "." + parts.slice(1).join("");
      }
    } else if (dataType === "Numeric/Whole Number") {
      // Allow only numbers(no decimal point)
      e.target.value = value.replace(/[^0-9]/g, "");
    } else if (dataType === "String") {
      // Allow only alphanumeric and spaces
      e.target.value = value.replace(/[^a-zA-Z0-9\s\.\,\-\(\)]/g, "");
    }

    // Always update the state with the value (restricted or unrestricted)
    // Note: Trimming is done before saving, not while typing, to allow users to type freely
    setEditModalData((prev) => ({
      ...prev,
      currentValue: e.target.value,
    }));
    
    // Clear error message when user starts typing
    if (editModalValidationError) {
      setEditModalValidationError("");
    }
  };

  // Check if editing is disabled
  const isEditingDisabled = () => {
    const toBeReviewed = apiData.noOfFieldsToBeReviewed || 0;
    const reviewed = apiData.noOfFieldsReviewed || 0;
    const isMarkedAsReviewed = apiData.markAsReviewed === true;
    
    // Enable editing when Mark as Complete button is visible
    // Button is visible when: !showingOriginal && (toBeReviewed > 0 || reviewed > 0) && !isMarkedAsReviewed
    if (!showingOriginal && (toBeReviewed > 0 || reviewed > 0) && !isMarkedAsReviewed) {
      return false; // Enable editing (but still check category for actual editability)
    }

    // Check if document is marked as reviewed (document-specific)
    const isDocumentMarkedAsReviewed = apiData.markAsReviewed === true;
    const hasNoPartialShipping = !batchDetails?.partialShippingDetails || batchDetails?.partialShippingDetails?.length === 0;
    
    // Special case: If document is marked as reviewed and no partial shipping, allow editing
    if (isDocumentMarkedAsReviewed && hasNoPartialShipping) {
      return false; // Enable editing irrespective of validation status
    }
    
    // Special case: For Post-Shipment Documents docs when reviewPostShipmentFieldsReqd is true and partialShippingDetails exists
    const customFile = batchDetails?.customFilesList?.find(
      file => file.schrockenCustomFileID === schrockenCustomFileID?.toString()
    );
    const category = customFile?.documentCategoryType;
    
    if (batchDetails?.reviewPostShipmentFieldsReqd === true && 
        batchDetails?.partialShippingDetails && 
        batchDetails.partialShippingDetails.length > 0 && 
        category === "Post-Shipment Documents") {
      return false; // Enable editing for Post-Shipment Documents docs in this scenario
    }
    
    
    
    // Check if there are fields needing validation
    let needsValidation = false;
    
    Object.keys(apiData).forEach((key) => {
      if (
        key !== "bowls" &&
        key !== "pallets" &&
        typeof apiData[key] === "object" &&
        apiData[key].needValidation === true
      ) {
        needsValidation = true;
      }
    });
    if (apiData.bowls) {
      apiData.bowls.forEach((bowl) => {
        bowl.rows.forEach((row) => {
          Object.keys(row).forEach((key) => {
            if (
              key !== "row_id" &&
              typeof row[key] === "object" &&
              row[key].needValidation === true
            ) {
              needsValidation = true;
            }
          });
        });
      });
    }

    if (apiData.pallets) {
      apiData.pallets.forEach((pallet) => {
        Object.keys(pallet).forEach((key) => {
          if (
            key !== "row_id" &&
            typeof pallet[key] === "object" &&
            pallet[key].needValidation === true
          ) {
            needsValidation = true;
          }
        });
      });
    }
    
    const result = !needsValidation;
    return result;
  };

  // Fetch field history
  const fetchFieldHistory = async (path, fieldLabel) => {
    try {
      setOpenModal(false);
      setIsFetchingHistory(true);
      const { dataFieldName, ID, rowID } = parseFieldPath(path, apiData);
      const requestPayload = {
        schrockenDeliveryScheduleBatchID:
          batchDetails?.schrockenDeliveryScheduleBatchID,
        documentType: docType,
        dataFieldName,
        ...(ID !== null && { ID: Number(ID) }), // Ensure ID is a number
        ...(rowID !== null && { rowID: Number(rowID) }), // Ensure rowID is a number
      };
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/fetchExtractedDataHistory`,
        requestPayload,
        { headers: { "Content-Type": "application/json" } }
      );
      if (
        response.data?.status &&
        response.data?.fieldDataHistory?.length > 0
      ) {
        const historyRecords = response.data.fieldDataHistory.map((record) => ({
          before: record.beforeValue || "N/A",
          after: record.afterValue || "N/A",
          updatedBy: record.lastUpdatedBy || "System",
          timestamp: record.lastUpdatedDate
            ? new Date(record.lastUpdatedDate).toLocaleString()
            : new Date().toLocaleString(),
        }));
        setModalData({
          field: fieldLabel,
          historyData: historyRecords,
          hasHistory: true,
        });
      } else {
        setModalData({
          field: fieldLabel,
          historyData: [],
          hasHistory: false,
        });
      }
      setOpenModal(true);
    } catch (error) {
      console.error(
        "Error fetching field history:",
        error.response?.data || error.message
      );
      setModalData({
        field: fieldLabel,
        historyData: [],
        hasHistory: false,
      });
      setOpenModal(true);
    } finally {
      setIsFetchingHistory(false);
    }
  };


  // Open edit modal
  const handleOpenEditModal = (path, fieldLabel) => {
    // Check if this is a bowl field (consumption details)
    const bowlsMatch = path.match(/bowls\[(\d+)\]\.rows\[(\d+)\]\.(.+)/);
    
    if (bowlsMatch) {
      const [, bowlIndex, rowIndex, fieldKey] = bowlsMatch;
      
      // Fields that are batch-related (not material fields)
      const batchRelatedFields = [
        'consumption_batch_number',
        'consumption_batch_number_sponsor',
        'actual_material_quantity_consumed',
        'consumption_batch_number_cmo'
      ];
      
      // Check if the field being edited is a batch-related field
      const isBatchField = batchRelatedFields.some(baseField => 
        fieldKey === baseField || fieldKey.startsWith(baseField + '_')
      );
      
      // If it's a batch field, validate that material number exists first
      if (isBatchField) {
        const bowl = apiData.bowls?.[parseInt(bowlIndex)];
        const firstRow = bowl?.rows?.[0];
        
        // Check if consumed_material_number fields have isVisibleOnUI: true
        const materialNumberSponsor = firstRow?.consumed_material_number_sponsor;
        const materialNumber = firstRow?.consumed_material_number;
        
        // Only show popup if at least one material number field is explicitly visible on UI (isVisibleOnUI === true)
        // If isVisibleOnUI is false or undefined, don't show the popup
        const isMaterialNumberSponsorVisible = materialNumberSponsor && materialNumberSponsor.isVisibleOnUI === true;
        const isMaterialNumberVisible = materialNumber && materialNumber.isVisibleOnUI === true;
        
        const anyMaterialNumberFieldVisible = isMaterialNumberSponsorVisible || isMaterialNumberVisible;
        
        if (anyMaterialNumberFieldVisible) {
          // Check if material number is filled in the first row
          const materialNumberValue = (materialNumberSponsor?.value || 
                                       materialNumber?.value || "").trim();
          
          if (!materialNumberValue) {
            // Show error dialog - material number must be filled first
            setShowMaterialNumberError(true);
            return; // Don't open edit modal
          }
        }
      }
    }
    
    const currentValue = getValueForField(path);
    const confidence = getConfidenceForField(path);
    const dataType = getDataTypeForField(path);
    setEditModalData({
      fieldKey: path,
      fieldLabel,
      currentValue,
      saveValue: currentValue,
      originalValue: currentValue,
      confidenceLevel: confidence,
      dataType,
      digitalizationCode: "",
      comment: "",
    });
    setEditModalValidationError("");
    setOpenEditModal(true);
  };

  // Save field edit
  const handleSaveFieldEdit = async () => {
    // if (
    //   editModalData.dataType &&
    //   !validateInput(editModalData.currentValue, editModalData.dataType)
    // ) {
    //   setEditModalValidationError(
    //     `Invalid ${editModalData.dataType.toLowerCase()} format`
    //   );
    //   return;
    // }
    // Check if mandatory field is empty
    if (isFieldMandatory(editModalData.fieldKey)) {
      const valueToCheck = editModalData.dataType === "Date" 
        ? editModalData.saveValue || editModalData.currentValue 
        : editModalData.currentValue;
      
      if (!valueToCheck || (typeof valueToCheck === 'string' && valueToCheck.trim() === "")) {
        setEditModalValidationError(
          `${editModalData.fieldLabel} is mandatory and cannot be empty`
        );
        return;
      }
    }

    if (!editModalData.digitalizationCode && !editModalData.comment.trim()) {
      setEditModalValidationError(
        "If digitalization code is not entered, comment field is mandatory"
      );
      return;
    }
    setEditModalValidationError("");
    try {
      setSaving(true);
      const fieldData = getNestedValue(apiData, editModalData.fieldKey);
      let valueToSave = editModalData.currentValue;
      if (editModalData.dataType === "Date") {
       if (editModalData.saveValue) {
         valueToSave = editModalData.saveValue;
       } else {
         valueToSave = editModalData.currentValue;
       }
      } else {
        // Trim leading and trailing spaces for better optimization (except for Date fields)
        valueToSave = typeof valueToSave === 'string' ? valueToSave.trim() : valueToSave;
      }
      // Trim comment field as well
      const trimmedComment = typeof editModalData.comment === 'string' ? editModalData.comment.trim() : editModalData.comment;
      
      // Check if this is a bowl field (consumption details)
      const isBowlField = editModalData.fieldKey.includes('bowls[');
      
      // Extract field name from path (e.g., "bowls[0].rows[0].consumed_material_number" -> "consumed_material_number")
      let fieldName = '';
      let currentBowlIndex = -1;
      let currentRowIndex = -1;
      if (isBowlField) {
        const match = editModalData.fieldKey.match(/bowls\[(\d+)\]\.rows\[(\d+)\]\.(.+)$/);
        if (match) {
          currentBowlIndex = parseInt(match[1]);
          currentRowIndex = parseInt(match[2]);
          fieldName = match[3];
        }
      }
      
      // Validation for consumption details fields only
      if (isBowlField && apiData.bowls && Array.isArray(apiData.bowls)) {
        // Check if editing consumed_material_number or consumed_material_number_sponsor
        const isMaterialField = fieldName === 'consumed_material_number' || fieldName === 'consumed_material_number_sponsor';
        // Check if editing consumption_batch_number or consumption_batch_number_sponsor
        const isBatchField = fieldName === 'consumption_batch_number' || fieldName === 'consumption_batch_number_sponsor';
        
        if (isMaterialField || isBatchField) {
          // Get current bowl's material number (check both fields)
          const currentBowl = apiData.bowls[currentBowlIndex];
          const currentRow = currentBowl?.rows?.[currentRowIndex];
          
          // Material number is always stored in the first row of the bowl
          const firstRowOfCurrentBowl = currentBowl?.rows?.[0];
          
          // Determine the new material number
          let newMaterialNumber = '';
          if (isMaterialField) {
            // User is editing the material field
            newMaterialNumber = valueToSave;
          } else {
            // User is editing batch field, get existing material number from first row of bowl
            // Material number is displayed only in first row but applies to entire bowl
            newMaterialNumber = firstRowOfCurrentBowl?.consumed_material_number_sponsor?.value || 
                               firstRowOfCurrentBowl?.consumed_material_number?.value || '';
          }
          
          // Determine the new batch number
          let newBatchNumber = '';
          if (isBatchField) {
            // User is editing the batch field
            newBatchNumber = valueToSave;
          } else {
            // User is editing material field, get existing batch number
            newBatchNumber = currentRow?.consumption_batch_number_sponsor?.value || 
                            currentRow?.consumption_batch_number?.value || '';
          }
          
          // Check for duplicates across all bowls and rows
          for (let bowlIndex = 0; bowlIndex < apiData.bowls.length; bowlIndex++) {
            const bowl = apiData.bowls[bowlIndex];
            if (!bowl.rows || !Array.isArray(bowl.rows)) continue;
            
            // Get material number from first row of this bowl (material is stored in first row)
            const firstRowOfBowl = bowl.rows[0];
            const existingMaterialNumber = firstRowOfBowl?.consumed_material_number_sponsor?.value || 
                                          firstRowOfBowl?.consumed_material_number?.value || '';
            
            for (let rowIndex = 0; rowIndex < bowl.rows.length; rowIndex++) {
              // Skip the current row being edited
              if (bowlIndex === currentBowlIndex && rowIndex === currentRowIndex) continue;
              
              const row = bowl.rows[rowIndex];
              const existingBatchNumber = row?.consumption_batch_number_sponsor?.value || 
                                         row?.consumption_batch_number?.value || '';
              
              // Check if material numbers match (case-insensitive, trimmed)
              const materialsMatch = existingMaterialNumber && newMaterialNumber && 
                                    existingMaterialNumber.toString().trim().toLowerCase() === 
                                    newMaterialNumber.toString().trim().toLowerCase();
              
              // Check if batch numbers match (case-insensitive, trimmed)
              // This compares the actual batch values users enter (e.g., "123" === "123")
              const batchesMatch = existingBatchNumber && newBatchNumber && 
                                  existingBatchNumber.toString().trim().toLowerCase() === 
                                  newBatchNumber.toString().trim().toLowerCase();
              
              // Validation 1: Check if editing material field and material already exists
              if (materialsMatch && isMaterialField) {
                setSaving(false);
                setEditModalValidationError(
                  "This material already exists. Please add a new batch for the existing material instead."
                );
                return;
              }
              
              // Validation 2: Check if editing batch field and same material + same batch value exists
              // Example: Material "MAT001" already has batch value "123" in "Consumption Batch Number BMS 1"
              //          User tries to enter "123" in "Consumption Batch Number BMS 2" for same material "MAT001"
              //          → Error: Batch already exists for this material
              if (materialsMatch && batchesMatch && isBatchField) {
                setSaving(false);
                setEditModalValidationError(
                  "The Consumption Batch Number already exists for this material. Please enter a new batch number."
                );
                return;
              }
            }
          }
        }
      }
      
      // For edited fields: needValidation = false
      // Preserve isMandatory value (true or false) from original field data
      const newFieldData = {
        ...fieldData,
        value: valueToSave,
        needValidation: false,
        reasonCode: editModalData.digitalizationCode,
        comment: trimmedComment,
        ...(fieldData?.isVisibleOnUI !== undefined && { isVisibleOnUI: fieldData.isVisibleOnUI }),
        // Preserve isMandatory value (true or false) if it exists in original field
        ...(fieldData?.isMandatory !== undefined && { isMandatory: fieldData.isMandatory }),
      };
      const newApiData = JSON.parse(JSON.stringify(apiData));
      setNestedValue(newApiData, editModalData.fieldKey, newFieldData);

      const wasFieldNeedingValidation = fieldData?.needValidation === true;
      const existingData = apiData;
      const updatedDocumentJSON = {};
      Object.keys(newApiData).forEach((fieldKey) => {
        if (
          fieldKey !== "bowls" &&
          typeof newApiData[fieldKey] === "object" &&
          "value" in newApiData[fieldKey]
        ) {
          const fieldData = newApiData[fieldKey];
          updatedDocumentJSON[fieldKey] = {
            value: fieldData.value,
            confidence: fieldData.confidence,
            ...(fieldData.dataType && { dataType: fieldData.dataType }),
            ...(fieldData.needValidation !== undefined && {
              needValidation: fieldData.needValidation,
            }),
            // Include isMandatory for all fields (including edited) to show mandatory star in UI
            ...(fieldData.isMandatory !== undefined && {
              isMandatory: fieldData.isMandatory,
            }),
            ...(fieldData.reasonCode !== undefined && { reasonCode: fieldData.reasonCode }),
            ...(fieldData.comment !== undefined && { comment: fieldData.comment }),
            ...(fieldData.isVisibleOnUI !== undefined && { isVisibleOnUI: fieldData.isVisibleOnUI }),
          };
        } else if (
          (fieldKey === "bowls" || fieldKey === "pallets") &&
          Array.isArray(newApiData[fieldKey])
        ) {
          // Remove isNew flag before sending to backend (it's only for local UI state)
          // Pass original bowls data to preserve all fields for existing rows
          const originalBowlsData = originalData[fieldKey];
          updatedDocumentJSON[fieldKey] = cleanBowlsForBackend(newApiData[fieldKey], originalBowlsData);
        }
      });

      [
        "document_type",
        "folder_name",
        "site_name",
        "filename",
        "s3_location",
        "markAsReviewed",
      ].forEach((field) => {
        if (existingData[field] !== undefined) {
          updatedDocumentJSON[field] = existingData[field];
        }
      });

      // Recalculate counts from the updated document structure
      let noOfFieldsToBeReviewed = 0;
      let noOfFieldsReviewed = 0;

      // Count regular fields
      Object.keys(updatedDocumentJSON).forEach((key) => {
        if (
          key !== "bowls" &&
          key !== "pallets" &&
          key !== "noOfFieldsToBeReviewed" &&
          key !== "noOfFieldsReviewed" &&
          typeof updatedDocumentJSON[key] === "object" &&
          "value" in updatedDocumentJSON[key] &&
          updatedDocumentJSON[key].needValidation !== undefined
        ) {
          // Only count mandatory fields in noOfFieldsToBeReviewed
          if (updatedDocumentJSON[key].needValidation === true && updatedDocumentJSON[key].isMandatory === true) {
            noOfFieldsToBeReviewed += 1;
          } else if (
            updatedDocumentJSON[key].needValidation === false &&
            // updatedDocumentJSON[key].isMandatory === true &&
            (updatedDocumentJSON[key].reasonCode || updatedDocumentJSON[key].comment)
          ) {
            // Only count as reviewed if it's mandatory and has been explicitly edited (has reasonCode or comment)
            noOfFieldsReviewed += 1;
          }
        }
      });

      // Count bowl fields
      if (Array.isArray(updatedDocumentJSON.bowls)) {
        updatedDocumentJSON.bowls.forEach((bowl) => {
          if (bowl.rows && Array.isArray(bowl.rows)) {
            bowl.rows.forEach((row) => {
              Object.keys(row).forEach((key) => {
                if (
                  key !== "row_id" &&
                  typeof row[key] === "object" &&
                  "value" in row[key] &&
                  row[key].needValidation !== undefined
                ) {
                  // Only count mandatory fields in noOfFieldsToBeReviewed
                  if (row[key].needValidation === true && row[key].isMandatory === true) {
                    noOfFieldsToBeReviewed += 1;
                  } else if (
                    row[key].needValidation === false &&
                    // row[key].isMandatory === true &&
                    (row[key].reasonCode || row[key].comment)
                  ) {
                    // Only count as reviewed if it has been explicitly edited (has reasonCode or comment)
                    noOfFieldsReviewed += 1;
                  }
                }
              });
            });
          }
        });
      }

      // Count pallet fields
      if (Array.isArray(updatedDocumentJSON.pallets)) {
        updatedDocumentJSON.pallets.forEach((pallet) => {
          Object.keys(pallet).forEach((key) => {
            if (
              key !== "row_id" &&
              typeof pallet[key] === "object" &&
              "value" in pallet[key] &&
              pallet[key].needValidation !== undefined
            ) {
              // Only count mandatory fields in noOfFieldsToBeReviewed
              if (pallet[key].needValidation === true && pallet[key].isMandatory === true) {
                noOfFieldsToBeReviewed += 1;
              } else if (
                pallet[key].needValidation === false &&
                // pallet[key].isMandatory === true &&
                (pallet[key].reasonCode || pallet[key].comment)
              ) {
                // Only count as reviewed if it has been explicitly edited (has reasonCode or comment)
                noOfFieldsReviewed += 1;
              }
            }
          });
        });
      }

      

      updatedDocumentJSON.noOfFieldsToBeReviewed = noOfFieldsToBeReviewed;
      updatedDocumentJSON.noOfFieldsReviewed = noOfFieldsReviewed;

      const requestPayload = {
        schrockenDeliveryScheduleID: batchDetails?.schrockenDeliveryScheduleID,
        schrockenDeliveryScheduleBatchID:
          batchDetails?.schrockenDeliveryScheduleBatchID,
        schrockenSLID: batchDetails?.schrockenSLID,
        kvpJsonEdited: updatedDocumentJSON,
        cdmoOrgID: batchDetails?.vendorMosymphonyID,
        poNumber: poNumber,
        batchNumber: batchNumber,
        cmoBatchNumber: batchDetails?.cmoBatchNumber || cmoBatchNumber,
        documentType: docType,
      };
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/handleDataExtractionEditedData`,
        requestPayload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success && response.data.cordaResponse?.status) {
        const updatedApiData = {
          ...newApiData,
          noOfFieldsToBeReviewed: noOfFieldsToBeReviewed,
          noOfFieldsReviewed: noOfFieldsReviewed
        };

        // Remove isNew flags from local state after successful save
        // This ensures that after saving, rows/bowls are no longer considered "new"
        if (newApiData.bowls && Array.isArray(newApiData.bowls)) {
          newApiData.bowls.forEach((bowl) => {

            delete bowl.isNew;
            if (bowl.rows && Array.isArray(bowl.rows)) {
              bowl.rows.forEach((row) => {
                delete row.isNew;
              });
            }
          });
        }
        
        // Only update UI state after successful API call
        setApiData({newApiData, ...updatedApiData});
        setEditedData({newApiData, ...updatedApiData});
        
        setOpenEditModal(false);
        setSuccessDialogTitle("Updated Successfully");
        setSuccessMessage(`${editModalData.fieldLabel} is updated.`);
        setShowSuccessDialog(true);
      } else {
        console.error(
          "Failed to save:",
          response.data.message || "Unknown error"
        );
        setEditModalValidationError(
          response.data.message || "Failed to update field. Please try again."
        );
      }
    } catch (error) {
      console.error(`Error saving ${docType} field:`, error);
      setEditModalValidationError(
        "An error occurred while saving. Please try again."
      );
    } finally {
      setSaving(false);
    }
  };

  // Handle review complete and workflow reset with unified function
  const handleReviewAction = async (resetWorkflow = false) => {
    try {
      setMarkingReviewComplete(true);
      setMarkReviewValidationErrors([]);

      const existingData = apiData;
      const updatedDocumentJSON = {};
      
      Object.keys(existingData).forEach((fieldKey) => {
        if (
          fieldKey !== "bowls" &&
          fieldKey !== "pallets" &&
          typeof existingData[fieldKey] === "object" &&
          "value" in existingData[fieldKey]
        ) {
          const fieldData = existingData[fieldKey];
          updatedDocumentJSON[fieldKey] = {
            value: fieldData.value,
            confidence: fieldData.confidence,
            ...(fieldData.dataType && { dataType: fieldData.dataType }),
            ...(fieldData.needValidation !== undefined && {
              needValidation: fieldData.needValidation,
            }),
            ...(fieldData.reasonCode !== undefined && { reasonCode: fieldData.reasonCode }),
            ...(fieldData.comment !== undefined && { comment: fieldData.comment }),
          };
        } else if (
          fieldKey === "bowls" &&
          Array.isArray(existingData[fieldKey])
        ) {
          updatedDocumentJSON[fieldKey] = existingData[fieldKey];
        } else if (
          fieldKey === "pallets" &&
          Array.isArray(existingData[fieldKey])
        ) {
          updatedDocumentJSON[fieldKey] = existingData[fieldKey];
        }
      });

      [
        "document_type",
        "folder_name",
        "site_name",
        "filename",
        "s3_location",
        "noOfFieldsToBeReviewed",
        "noOfFieldsReviewed",
      ].forEach((field) => {
        if (existingData[field] !== undefined) {
          updatedDocumentJSON[field] = existingData[field];
        }
      });

      // Add markAsReviewed flag to kvpJsonEdited
      updatedDocumentJSON.markAsReviewed = true;

      const requestPayload = {
        schrockenDeliveryScheduleID: batchDetails?.schrockenDeliveryScheduleID,
        schrockenDeliveryScheduleBatchID:
          batchDetails?.schrockenDeliveryScheduleBatchID,
        schrockenSLID: batchDetails?.schrockenSLID,
        kvpJsonEdited: updatedDocumentJSON,
        cdmoOrgID: batchDetails?.vendorMosymphonyID,
        poNumber: poNumber,
        batchNumber: batchNumber,
        cmoBatchNumber: batchDetails?.cmoBatchNumber || cmoBatchNumber,
        documentType: docType,
        ...(resetWorkflow && { resetWorkflow: true }),
      };

      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/handleDataExtractionEditedData`,
        requestPayload,
        { headers: { "Content-Type": "application/json" } }
      );

      // BCM-348: check validationErrors from backend before proceeding
      if (
        response.data.validation?.validationErrors &&
        response.data.validation.validationErrors.length > 0
      ) {
        setMarkReviewValidationErrors(response.data.validation.validationErrors);
        // Refresh data so backend-updated kvpJsonEdited (needValidation=true fields, markAsReviewed=false) loads on UI
        if (onDataRefresh) onDataRefresh();
        return;
      }

      if (response.data.success && response.data.cordaResponse?.status) {
        if (resetWorkflow) {
          setSuccessDialogTitle("Workflow reset successfully.");
          setSuccessMessage("Process flow changes have been reinitiated.");
        } else {
          setSuccessDialogTitle("Marked review as complete.");
          setSuccessMessage("Process flow change is initiated.");
        }
        setShowSuccessDialog(true);

        // Optionally refresh the data
        if (onDataRefresh) {
          onDataRefresh();
        }
      } else {
        const action = resetWorkflow ? "reset workflow" : "mark review as complete";
        console.error(
          `Failed to ${action}:`,
          response.data.message || "Unknown error"
        );
      }
    } catch (error) {
      const action = resetWorkflow ? "resetting workflow" : "marking review as complete";
      console.error(`Error ${action}:`, error);
    } finally {
      setMarkingReviewComplete(false);
    }
  };

  // Handle close with warning check
  const handleClose = () => {
    
    if (!isFeaturesAccessLoaded) {
      onClose();
      return;
    }
    
    const toBeReviewed = apiData.noOfFieldsToBeReviewed || 0;
    const reviewed = apiData.noOfFieldsReviewed || 0;
    const isMarkedAsReviewed = apiData.markAsReviewed === true;
    const isCategoryEditable = isDocumentCategoryEditable();
    const shouldWarn = canReviewAndEdit() && !showingOriginal && (toBeReviewed === 0 && reviewed > 0) && !isMarkedAsReviewed && isCategoryEditable;
    
    if (shouldWarn) {
      setShowExitWarning(true);
    } else {
      onClose();
    }
  };

  // Populate the ref with handleClose function so parent can call it
  useEffect(() => {
    if (handleCloseRef) {
      handleCloseRef.current = handleClose;
    }
  }, [handleCloseRef, apiData.noOfFieldsToBeReviewed, apiData.noOfFieldsReviewed, showingOriginal, featuresAccess, isFeaturesAccessLoaded]);

  // Helper function to remove isNew flag from bowls and rows (local UI flag, not sent to backend)
  // Also removes isMandatory from fields in new rows/bowls
  // Converts empty strings to null for consumption details fields
  // Merges existing rows with original data to preserve all fields
  const cleanBowlsForBackend = (bowls, originalBowls = null) => {
    if (!Array.isArray(bowls)) return bowls;
    return bowls.map((bowl, bowlIndex) => {
      const cleanedBowl = { ...bowl };
      const isBowlNew = cleanedBowl.isNew === true;
      // Remove isNew flag from bowl
      delete cleanedBowl.isNew;
      
      // Find corresponding original bowl for merging
      let originalBowl = null;
      if (originalBowls && Array.isArray(originalBowls)) {
        const bowlId = cleanedBowl.ID || cleanedBowl.bowl?.value;
        if (bowlId) {
          originalBowl = originalBowls.find(b => 
            (b.ID === bowlId) || (b.bowl?.value === bowlId)
          );
        }
      }
      
      // Clean rows if they exist
      if (cleanedBowl.rows && Array.isArray(cleanedBowl.rows)) {
        cleanedBowl.rows = cleanedBowl.rows.map((row) => {
          const cleanedRow = { ...row };
          const isRowNew = cleanedRow.isNew === true || isBowlNew;
          const rowId = cleanedRow.row_id;
          
          // Find corresponding original row for merging (for existing rows only)
          let originalRow = null;
          if (!isRowNew && rowId && originalBowl && originalBowl.rows && Array.isArray(originalBowl.rows)) {
            originalRow = originalBowl.rows.find(r => r.row_id === rowId);
          }
          
          // If this is an existing row, merge with original row to preserve all fields
          if (originalRow && !isRowNew) {
            // Start with original row data
            const mergedRow = { ...originalRow };
            
            // Override with current row data (preserving all original fields)
            Object.keys(cleanedRow).forEach((key) => {
              if (key !== "row_id" && key !== "isNew") {
                mergedRow[key] = cleanedRow[key];
              }
            });
            
            // Copy row_id from cleaned row
            if (cleanedRow.row_id) {
              mergedRow.row_id = cleanedRow.row_id;
            }
            
            // Process all fields in the merged row
            Object.keys(mergedRow).forEach((key) => {
              if (
                key !== "row_id" &&
                typeof mergedRow[key] === "object" &&
                mergedRow[key] !== null &&
                "value" in mergedRow[key]
              ) {
                // Convert empty strings to null for consumption details fields
                if (typeof mergedRow[key].value === 'string' && mergedRow[key].value.trim() === '') {
                  mergedRow[key].value = null;
                }
                
                // For merged rows (existing rows), ensure edited fields have correct flags
                // If field was edited (needValidation = false and has reasonCode/comment), preserve original isMandatory
                // But only if field is visible on UI (we only send needValidation/isMandatory for visible fields)
                // Preserve isMandatory value (true or false) from original field data
                const currentField = mergedRow[key];
                const isFieldVisibleOnUI = currentField.isVisibleOnUI !== false;
                
                if (currentField.needValidation === false && (currentField.reasonCode || currentField.comment)) {
                  // Field was edited: needValidation = false
                  // Preserve isMandatory value (true or false) if it exists
                  // Only preserve these flags if field is visible on UI
                  if (isFieldVisibleOnUI) {
                    mergedRow[key] = {
                      ...currentField,
                      needValidation: false,
                      // Preserve isMandatory value (true or false) if it exists
                      ...(currentField.isMandatory !== undefined && { isMandatory: currentField.isMandatory })
                    };
                  } else {
                    // Field was edited but not visible - remove needValidation/isMandatory but keep reasonCode/comment
                    const { isMandatory, needValidation, ...fieldWithoutFlags } = currentField;
                    mergedRow[key] = {
                      ...fieldWithoutFlags,
                      value: currentField.value,
                      confidence: currentField.confidence,
                      ...(currentField.dataType && { dataType: currentField.dataType }),
                      ...(currentField.reasonCode !== undefined && { reasonCode: currentField.reasonCode }),
                      ...(currentField.comment !== undefined && { comment: currentField.comment }),
                      ...(currentField.isVisibleOnUI !== undefined && { isVisibleOnUI: currentField.isVisibleOnUI }),
                    };
                  }
                } else if (!isFieldVisibleOnUI && (currentField.needValidation !== undefined || currentField.isMandatory !== undefined)) {
                  // Field is not visible and has needValidation/isMandatory - remove them
                  const { isMandatory, needValidation, ...fieldWithoutFlags } = currentField;
                  mergedRow[key] = {
                    ...fieldWithoutFlags,
                    value: currentField.value,
                    confidence: currentField.confidence,
                    ...(currentField.dataType && { dataType: currentField.dataType }),
                    ...(currentField.reasonCode !== undefined && { reasonCode: currentField.reasonCode }),
                    ...(currentField.comment !== undefined && { comment: currentField.comment }),
                    ...(currentField.isVisibleOnUI !== undefined && { isVisibleOnUI: currentField.isVisibleOnUI }),
                  };
                }
              }
            });
            
            return mergedRow;
          } else {
            // For new rows, process as before
            // Remove isNew flag from row
            delete cleanedRow.isNew;
            
            // Fields that should have isMandatory: true and needValidation: true for new rows
            const mandatoryFieldsForNewRows = [
              'consumption_batch_number_sponsor',
              'actual_material_quantity_consumed'
            ];
            
            // Process all fields in the row
            Object.keys(cleanedRow).forEach((key) => {
              if (
                key !== "row_id" &&
                typeof cleanedRow[key] === "object" &&
                cleanedRow[key] !== null &&
                "value" in cleanedRow[key]
              ) {
                // Convert empty strings to null for consumption details fields
                if (typeof cleanedRow[key].value === 'string' && cleanedRow[key].value.trim() === '') {
                  cleanedRow[key].value = null;
                }
                
                // If row is new, set isMandatory and needValidation based on field type and visibility
                // Only visible fields should have needValidation and isMandatory
                if (isRowNew) {
                  const isMandatoryField = mandatoryFieldsForNewRows.includes(key);
                  // Check if field is visible on UI (true if undefined or explicitly true)
                  const isFieldVisibleOnUI = cleanedRow[key].isVisibleOnUI !== false;
                  
                  if (isFieldVisibleOnUI) {
                    // For visible fields: preserve needValidation if it was explicitly set to false (field was edited)
                    // Otherwise set to true for visible fields
                    const preservedNeedValidation = cleanedRow[key].needValidation === false ? false : true;
                    
                    if (isMandatoryField) {
                      // Mandatory visible fields: set both isMandatory and needValidation
                      cleanedRow[key] = {
                        ...cleanedRow[key],
                        isMandatory: true,
                        needValidation: preservedNeedValidation
                      };
                    } else {
                      // Non-mandatory visible fields: only set needValidation, remove isMandatory
                      const { isMandatory, ...fieldWithoutMandatory } = cleanedRow[key];
                      cleanedRow[key] = {
                        ...fieldWithoutMandatory,
                        needValidation: preservedNeedValidation
                      };
                    }
                  } else {
                    // Fields not visible on UI: remove both needValidation and isMandatory
                    const { isMandatory, needValidation, ...fieldWithoutFlags } = cleanedRow[key];
                    cleanedRow[key] = {
                      ...fieldWithoutFlags
                    };
                  }
                } else {
                  // For existing rows, process edited fields
                  const currentField = cleanedRow[key];
                  const isFieldVisibleOnUI = currentField.isVisibleOnUI !== false;
                  
                  if (currentField.needValidation === false && (currentField.reasonCode || currentField.comment)) {
                    // Field was edited: needValidation = false
                    // Preserve isMandatory value (true or false) if it exists
                    // Only preserve these flags if field is visible on UI
                    if (isFieldVisibleOnUI) {
                      cleanedRow[key] = {
                        ...currentField,
                        needValidation: false,
                        // Preserve isMandatory value (true or false) if it exists
                        ...(currentField.isMandatory !== undefined && { isMandatory: currentField.isMandatory })
                      };
                    } else {
                      // Field was edited but not visible - remove needValidation/isMandatory but keep reasonCode/comment
                      const { isMandatory, needValidation, ...fieldWithoutFlags } = currentField;
                      cleanedRow[key] = {
                        ...fieldWithoutFlags,
                        value: currentField.value,
                        confidence: currentField.confidence,
                        ...(currentField.dataType && { dataType: currentField.dataType }),
                        ...(currentField.reasonCode !== undefined && { reasonCode: currentField.reasonCode }),
                      ...(currentField.comment !== undefined && { comment: currentField.comment }),
                        ...(currentField.isVisibleOnUI !== undefined && { isVisibleOnUI: currentField.isVisibleOnUI }),
                      };
                    }
                  } else if (!isFieldVisibleOnUI) {
                    // Field is not visible and not edited - remove needValidation/isMandatory
                    const { isMandatory, needValidation, ...fieldWithoutFlags } = currentField;
                    cleanedRow[key] = {
                      ...fieldWithoutFlags,
                      value: currentField.value,
                      confidence: currentField.confidence,
                      ...(currentField.dataType && { dataType: currentField.dataType }),
                      ...(currentField.reasonCode !== undefined && { reasonCode: currentField.reasonCode }),
                        ...(currentField.comment !== undefined && { comment: currentField.comment }),
                      ...(currentField.isVisibleOnUI !== undefined && { isVisibleOnUI: currentField.isVisibleOnUI }),
                    };
                  }
                  // If field is visible and not edited, keep as is (needValidation/isMandatory preserved from original)
                }
              }
            });
            
            return cleanedRow;
          }
        });
      }
      return cleanedBowl;
    });
  };

  // Function to save data to API (reusable for both edit and delete operations)
  const saveDataToAPI = async (dataToSave, successMessage = "Data saved successfully!") => {
    try {
      const existingData = dataToSave;
      const updatedDocumentJSON = {};
      Object.keys(dataToSave).forEach((fieldKey) => {
        if (
          fieldKey !== "bowls" &&
          fieldKey !== "pallets" &&
          typeof dataToSave[fieldKey] === "object" &&
          "value" in dataToSave[fieldKey]
        ) {
          const fieldData = dataToSave[fieldKey];
          updatedDocumentJSON[fieldKey] = {
            value: fieldData.value,
            confidence: fieldData.confidence,
            ...(fieldData.dataType && { dataType: fieldData.dataType }),
            ...(fieldData.needValidation !== undefined && {
              needValidation: fieldData.needValidation,
            }),
            ...(fieldData.isMandatory !== undefined && {
              isMandatory: fieldData.isMandatory,
            }),
            ...(fieldData.reasonCode !== undefined && { reasonCode: fieldData.reasonCode }),
            ...(fieldData.comment !== undefined && { comment: fieldData.comment }),
            ...(fieldData.isVisibleOnUI !== undefined && { isVisibleOnUI: fieldData.isVisibleOnUI }),
          };
        } else if (
          fieldKey === "bowls" &&
          Array.isArray(dataToSave[fieldKey])
        ) {
          // Remove isNew flag before sending to backend (it's only for local UI state)
          // Pass original bowls data to preserve all fields for existing rows
          const originalBowlsData = originalData[fieldKey];
          updatedDocumentJSON[fieldKey] = cleanBowlsForBackend(dataToSave[fieldKey], originalBowlsData);
        } else if (
          fieldKey === "pallets" &&
          Array.isArray(dataToSave[fieldKey])
        ) {
          updatedDocumentJSON[fieldKey] = dataToSave[fieldKey];
        }
      });

      [
        "document_type",
        "folder_name",
        "site_name",
        "filename",
        "s3_location",
      ].forEach((field) => {
        if (existingData[field]) {
          updatedDocumentJSON[field] = existingData[field];
        }
      });

      // Recalculate counts from the updated document structure
      let noOfFieldsToBeReviewed = 0;
      let noOfFieldsReviewed = 0;

      // Count regular fields - only count fields with needValidation: true AND isMandatory: true
      Object.keys(updatedDocumentJSON).forEach((key) => {
        if (
          key !== "bowls" &&
          key !== "pallets" &&
          key !== "noOfFieldsToBeReviewed" &&
          key !== "noOfFieldsReviewed" &&
          typeof updatedDocumentJSON[key] === "object" &&
          "value" in updatedDocumentJSON[key] &&
          updatedDocumentJSON[key].needValidation !== undefined
        ) {
          // Only count mandatory fields in noOfFieldsToBeReviewed
          if (updatedDocumentJSON[key].needValidation === true && updatedDocumentJSON[key].isMandatory === true) {
            noOfFieldsToBeReviewed += 1;
          } else if (
            updatedDocumentJSON[key].needValidation === false &&
            // updatedDocumentJSON[key].isMandatory === true &&
            (updatedDocumentJSON[key].reasonCode || updatedDocumentJSON[key].comment)
          ) {
            // Only count as reviewed if it has been explicitly edited (has reasonCode or comment)
            noOfFieldsReviewed += 1;
          }
        }
      });

      // Count bowl fields - only count fields with needValidation: true AND isMandatory: true
      if (Array.isArray(updatedDocumentJSON.bowls)) {
        updatedDocumentJSON.bowls.forEach((bowl) => {
          if (bowl.rows && Array.isArray(bowl.rows)) {
            bowl.rows.forEach((row) => {
              Object.keys(row).forEach((key) => {
                if (
                  key !== "row_id" &&
                  typeof row[key] === "object" &&
                  "value" in row[key] &&
                  row[key].needValidation !== undefined
                ) {
                  // Only count mandatory fields in noOfFieldsToBeReviewed
                  if (row[key].needValidation === true && row[key].isMandatory === true) {
                    noOfFieldsToBeReviewed += 1;
                  } else if (
                    row[key].needValidation === false &&
                    // row[key].isMandatory === true &&
                    (row[key].reasonCode || row[key].comment)
                  ) {
                    // Only count as reviewed if it has been explicitly edited (has reasonCode or comment)
                    noOfFieldsReviewed += 1;
                  }
                }
              });
            });
          }
        });
      }

      updatedDocumentJSON.noOfFieldsToBeReviewed = noOfFieldsToBeReviewed;
      updatedDocumentJSON.noOfFieldsReviewed = noOfFieldsReviewed;

      const requestPayload = {
        schrockenDeliveryScheduleID: batchDetails?.schrockenDeliveryScheduleID,
        schrockenDeliveryScheduleBatchID:
          batchDetails?.schrockenDeliveryScheduleBatchID,
        schrockenSLID: batchDetails?.schrockenSLID,
        kvpJsonEdited: updatedDocumentJSON,
        cdmoOrgID: batchDetails?.vendorMosymphonyID,
        poNumber: poNumber,
        batchNumber: batchNumber,
        cmoBatchNumber: batchDetails?.cmoBatchNumber || cmoBatchNumber,
        documentType: docType,
      };
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/handleDataExtractionEditedData`,
        requestPayload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success && response.data.cordaResponse?.status) {
        // Update dataToSave with the calculated counts
        // const updatedDataToSave = {
        //   ...dataToSave,
        //   noOfFieldsToBeReviewed: noOfFieldsToBeReviewed,
        //   noOfFieldsReviewed: noOfFieldsReviewed
        // };
        
        // Remove isNew flags from local state after successful save
        // This ensures that after saving, rows/bowls are no longer considered "new"
        if (dataToSave.bowls && Array.isArray(dataToSave.bowls)) {
          dataToSave.bowls.forEach((bowl) => {
            delete bowl.isNew;
            if (bowl.rows && Array.isArray(bowl.rows)) {
              bowl.rows.forEach((row) => {
                delete row.isNew;
              });
            }
          });
        }
        
        setApiData(dataToSave);
        setEditedData(dataToSave);
        
        setSuccessMessage(successMessage);
        setShowSuccessDialog(true);
        return true;
      } else {
        console.error(
          "Failed to save:",
          response.data.message || "Unknown error"
        );
        throw new Error(response.data.message || "Failed to save data. Please try again.");
      }
    } catch (error) {
      console.error(`Error saving data:`, error);
      throw error;
    }
  };

  // Handler to show delete confirmation dialog for batch
  const handleDeleteBatchClick = (bowlIndex, rowIndex, batchNumber, batchLabel, isStatic = false) => {
    if (isStatic) {
      return;
    }
    
    // Safely get the row to delete
    if (!apiData.bowls || !apiData.bowls[bowlIndex] || !apiData.bowls[bowlIndex].rows || !apiData.bowls[bowlIndex].rows[rowIndex]) {
      console.error("Row not found for deletion");
      return;
    }
    
    const rowToDelete = apiData.bowls[bowlIndex].rows[rowIndex];
    const isNew = rowToDelete?.isNew === true;
    
    // If it's a new row (not saved yet), delete directly from UI without API call
    if (isNew) {
      handleDeleteBatch(bowlIndex, rowIndex, 1, false);
      return;
    }
    
    const bowl = apiData.bowls[bowlIndex];
    const consumptionDetailsLabel = bowl ? `Consumption Details ${bowl.bowl?.value || bowl.ID}` : "Consumption Details";
    
    // Helper to get material number value from a row
    const getMaterialNumberValue = (row) => {
      return (row?.consumed_material_number_sponsor && typeof row.consumed_material_number_sponsor === 'object' && row.consumed_material_number_sponsor.value) || 
             (row?.consumed_material_number && typeof row.consumed_material_number === 'object' && row.consumed_material_number.value) || 
             null;
    };
    
    // Get material number from current row, or fallback to first row if not found
    let materialNumber = getMaterialNumberValue(rowToDelete);
    if (!materialNumber && bowl?.rows && bowl.rows.length > 0 && rowIndex > 0) {
      // For rows after the first one, material number is stored in the first row
      const firstRow = bowl.rows[0];
      materialNumber = getMaterialNumberValue(firstRow);
    }
    materialNumber = materialNumber || "N/A";
    
    const batchNumberValue = (rowToDelete?.consumption_batch_number_sponsor && typeof rowToDelete.consumption_batch_number_sponsor === 'object' && rowToDelete.consumption_batch_number_sponsor.value) || "N/A";
    
    setDeleteConfirmData({
      type: "batch",
      bowlIndex,
      rowIndex,
      batchNumber: 1,
      consumptionDetailsLabel,
      materialNumber,
      batchNumberValue,
      quantity: "", // Not needed for batch deletion popup
    });
    setShowDeleteConfirmDialog(true);
  };
  
  // Handler to delete consumed batch (called after confirmation)
  const handleDeleteBatch = (bowlIndex, rowIndex, batchNumber, isStatic = false) => {
    if (isStatic) {
      return null;
    }

    const newApiData = JSON.parse(JSON.stringify(apiData));
    if (!newApiData.bowls || !newApiData.bowls[bowlIndex] || !newApiData.bowls[bowlIndex].rows || !newApiData.bowls[bowlIndex].rows[rowIndex]) {
      return null;
    }

    newApiData.bowls[bowlIndex].rows.splice(rowIndex, 1);
    
    setApiData(newApiData);
    setEditedData(newApiData);
    return newApiData;
  };

  // Helper to check if bowl exists in originalData
  const isBowlFromBackend = (bowlIndex) => {
    const currentBowl = apiData.bowls?.[bowlIndex];
    if (!currentBowl) {
      return false;
    }
    
    const bowlId = currentBowl.ID || currentBowl.bowl?.value;
    if (!bowlId) {
      return false;
    }
    
    if (!originalData.bowls || !Array.isArray(originalData.bowls)) {
      return false;
    }
    
    return originalData.bowls.some(bowl => (bowl.ID === bowlId) || (bowl.bowl?.value === bowlId));
  };

  // Handler to show delete confirmation dialog for consumption section
  const handleDeleteConsumptionSectionClick = (bowlIndex, isStatic = false) => {
    if (isStatic) {
      return;
    }
    
    const bowl = apiData.bowls?.[bowlIndex];
    const isNew = bowl?.isNew === true;
    
    if (isNew) {
      handleDeleteConsumptionSection(bowlIndex, false);
      return;
    }
    
    const consumptionDetailsLabel = bowl ? `Consumption Details ${bowl.bowl?.value || bowl.ID}` : "Consumption Details";
    
    setDeleteConfirmData({
      type: "consumptionSection",
      bowlIndex,
      rowIndex: null,
      batchNumber: null,
      consumptionDetailsLabel,
    });
    setShowDeleteConfirmDialog(true);
  };
  
  // Helper function to renumber bowls sequentially
  // ID should be numeric (1, 2, 3...), bowl.value should be alphabetic (A, B, C...)
  const renumberBowls = (bowls) => {
    if (!bowls || !Array.isArray(bowls)) return bowls;
    
    return bowls.map((bowl, index) => {
      const numericId = index + 1; // 1, 2, 3, 4, etc.
      const alphabeticValue = String.fromCharCode(65 + index); // A=65, B=66, C=67, etc.
      const updatedBowl = { ...bowl };
      updatedBowl.ID = numericId;
      
      // Update bowl.value if it exists (alphabetic)
      if (updatedBowl.bowl && typeof updatedBowl.bowl === 'object') {
        updatedBowl.bowl = {
          ...updatedBowl.bowl,
          value: alphabeticValue
        };
      } else {
        updatedBowl.bowl = { value: alphabeticValue, confidence: "0", dataType: "String" };
      }
      
      return updatedBowl;
    });
  };

  // Handler to delete consumption section (bowl) - called after confirmation
  const handleDeleteConsumptionSection = (bowlIndex, isStatic = false) => {
    if (isStatic) {
      return null;
    }

    const newApiData = JSON.parse(JSON.stringify(apiData));
    if (!newApiData.bowls || !newApiData.bowls[bowlIndex]) {
      return null;
    }
    
    // Remove the bowl at the specified index
    newApiData.bowls.splice(bowlIndex, 1);
    
    // Renumber remaining bowls sequentially (A, B, C, D...)
    newApiData.bowls = renumberBowls(newApiData.bowls);
    
    setApiData(newApiData);
    setEditedData(newApiData);
    return newApiData;
  };

  // Handler to confirm deletion
  const handleConfirmDelete = async () => {
    try {
      setDeleteError("");
      setSaving(true);
      
      // Check if the item being deleted is new (not saved yet)
      let isNewItem = false;
      if (deleteConfirmData.type === "batch") {
        const rowToDelete = apiData.bowls?.[deleteConfirmData.bowlIndex]?.rows?.[deleteConfirmData.rowIndex];
        isNewItem = rowToDelete?.isNew === true;
      } else if (deleteConfirmData.type === "consumptionSection") {
        const bowlToDelete = apiData.bowls?.[deleteConfirmData.bowlIndex];
        isNewItem = bowlToDelete?.isNew === true;
      }
      
      let updatedData = null;
      if (deleteConfirmData.type === "batch") {
        updatedData = handleDeleteBatch(deleteConfirmData.bowlIndex, deleteConfirmData.rowIndex, deleteConfirmData.batchNumber, false);
      } else if (deleteConfirmData.type === "consumptionSection") {
        updatedData = handleDeleteConsumptionSection(deleteConfirmData.bowlIndex, false);
      }
      
      if (!updatedData) {
        throw new Error("Failed to perform deletion operation");
      }
      
      const deleteMessage = deleteConfirmData.type === "batch" 
        ? `Batch deleted successfully!`
        : `${deleteConfirmData.consumptionDetailsLabel} deleted successfully!`;
      
      // If it's a new item (not saved yet), just update UI without API call
      // Otherwise, save to API
      if (isNewItem) {
        // Just update the state, no API call needed
        // Close dialog and show success immediately
        setShowDeleteConfirmDialog(false);
        setDeleteConfirmData({
          type: "",
          bowlIndex: null,
          rowIndex: null,
          batchNumber: null,
          consumptionDetailsLabel: "",
          materialNumber: "",
          batchNumberValue: "",
          quantity: "",
        });
        setSuccessMessage(deleteMessage);
        setShowSuccessDialog(true);
      } else {
        // Item was saved before, need to call API to delete it
        // Keep dialog open with loader until API call completes
        // saveDataToAPI will handle showing the success dialog
        await saveDataToAPI(updatedData, deleteMessage);
        
        // After successful API call, close the delete dialog
        // (success dialog is already shown by saveDataToAPI)
        setShowDeleteConfirmDialog(false);
        setDeleteConfirmData({
          type: "",
          bowlIndex: null,
          rowIndex: null,
          batchNumber: null,
          consumptionDetailsLabel: "",
          materialNumber: "",
          batchNumberValue: "",
          quantity: "",
        });
      }
    } catch (error) {
      console.error("Error deleting:", error);
      // Keep dialog open and show error message
      setDeleteError(
        error.message || "An error occurred while deleting. Please try again."
      );
    } finally {
      setSaving(false);
    }
  };

  // Handler to add new consumed batch (adds a new row)
  const handleAddNewConsumedBatch = (bowlIndex, rowIndex, isStatic = false) => {
    if (isStatic) {
      return;
    }

    const newApiData = JSON.parse(JSON.stringify(apiData));
    if (!newApiData.bowls || !newApiData.bowls[bowlIndex]) {
      return;
    }
    
    if (!newApiData.bowls[bowlIndex].rows) {
      newApiData.bowls[bowlIndex].rows = [];
    }
    
    // Validation: Check if material number is filled in the first row before adding new batch
    if (newApiData.bowls[bowlIndex].rows.length > 0) {
      const firstRow = newApiData.bowls[bowlIndex].rows[0];
      
      // Check if consumed_material_number fields have isVisibleOnUI: true
      const materialNumberSponsor = firstRow?.consumed_material_number_sponsor;
      const materialNumber = firstRow?.consumed_material_number;
      
      // Only show popup if at least one material number field is explicitly visible on UI (isVisibleOnUI === true)
      // If isVisibleOnUI is false or undefined, don't show the popup
      const isMaterialNumberSponsorVisible = materialNumberSponsor && materialNumberSponsor.isVisibleOnUI === true;
      const isMaterialNumberVisible = materialNumber && materialNumber.isVisibleOnUI === true;
      
      const anyMaterialNumberFieldVisible = isMaterialNumberSponsorVisible || isMaterialNumberVisible;
      
      if (anyMaterialNumberFieldVisible) {
        const materialNumberValue = (materialNumberSponsor?.value || 
                                     materialNumber?.value || "").trim();
        
        if (!materialNumberValue) {
          // Show error dialog - material number must be filled first
          setShowMaterialNumberError(true);
          return;
        }
      }
    }
    
    const lastRow = newApiData.bowls[bowlIndex].rows.length > 0 
      ? newApiData.bowls[bowlIndex].rows[newApiData.bowls[bowlIndex].rows.length - 1]
      : null;
    
    const nextRowId = newApiData.bowls[bowlIndex].rows.length > 0
      ? Math.max(...newApiData.bowls[bowlIndex].rows.map(r => r.row_id || 0)) + 1
      : 1;
    
    // Get reference row to copy all field structure from (use first row if available)
    const referenceRow = newApiData.bowls[bowlIndex].rows.length > 0 
      ? newApiData.bowls[bowlIndex].rows[0]
      : null;
    
    const newRow = {
      row_id: nextRowId,
      isNew: true
    };
    
    // Copy ALL fields from reference row (or lastRow if it exists) to ensure all fields are included
    const rowToCopyFrom = lastRow || referenceRow;
    
    // Fields that should be mandatory for new consumed batches
    const mandatoryFieldsForNewBatches = [
      'consumption_batch_number_sponsor',
      'consumption_batch_number',
      'actual_material_quantity_consumed'
    ];
    
    if (rowToCopyFrom) {
      // Get all field names from the row to copy from
      Object.keys(rowToCopyFrom).forEach((key) => {
        if (key !== "row_id" && key !== "isNew" && typeof rowToCopyFrom[key] === "object" && "value" in rowToCopyFrom[key]) {
          // Copy the field structure but set value to empty
          const fieldData = rowToCopyFrom[key];
          // Check if field is visible on UI (true if undefined or explicitly true)
          const isFieldVisibleOnUI = fieldData.isVisibleOnUI !== false;
          const isMandatoryField = mandatoryFieldsForNewBatches.includes(key);
          
          // Only set needValidation and isMandatory for fields visible on UI
          if (isFieldVisibleOnUI) {
            // Set needValidation: true for visible fields (so edit icon appears)
            const shouldNeedValidation = true;
            
            newRow[key] = {
              confidence: "0",
              dataType: fieldData.dataType || "String",
              needValidation: shouldNeedValidation,
              value: "",
              // Only set isMandatory for mandatory fields that are visible on UI
              ...(isMandatoryField && { isMandatory: true }),
              ...(fieldData.isVisibleOnUI !== undefined && { isVisibleOnUI: fieldData.isVisibleOnUI })
            };
          } else {
            // For non-visible fields, don't set needValidation or isMandatory
            newRow[key] = {
              confidence: "0",
              dataType: fieldData.dataType || "String",
              value: "",
              ...(fieldData.isVisibleOnUI !== undefined && { isVisibleOnUI: fieldData.isVisibleOnUI })
            };
          }
        }
      });
    } else {
      // Fallback: create default fields if no reference row exists
      newRow.consumption_batch_number_sponsor = {
        confidence: "0",
        dataType: "String",
        needValidation: true,
        value: "",
        isMandatory: true,
        isVisibleOnUI: true
      };
      newRow.actual_material_quantity_consumed = {
        confidence: "0",
        dataType: "Numeric",
        needValidation: true,
        value: "",
        isMandatory: true,
        isVisibleOnUI: true
      };
      newRow.consumed_material_number_sponsor = {
        confidence: "0",
        dataType: "String",
        needValidation: true, // Visible field, needs edit icon
        value: "",
        isVisibleOnUI: true
      };
    }
    
    newApiData.bowls[bowlIndex].rows.push(newRow);

    setApiData(newApiData);
    setEditedData(newApiData);
  };

  // Handler to add new consumed material (new consumption details section)
  const handleAddNewConsumedMaterial = () => {
    const newApiData = JSON.parse(JSON.stringify(apiData));
    if (!newApiData.bowls) {
      newApiData.bowls = [];
    }

    // Find max numeric ID and max alphabetic value for bowl.value
    let maxNumericId = 0;
    let maxBowlCharCode = 64;
    
    newApiData.bowls.forEach(bowl => {
      // Check numeric ID
      const numericId = typeof bowl.ID === 'number' ? bowl.ID : 
                        (typeof bowl.ID === 'string' && !isNaN(parseInt(bowl.ID)) ? parseInt(bowl.ID) : 0);
      if (numericId > maxNumericId) {
        maxNumericId = numericId;
      }
      
      // Check alphabetic bowl.value
      const bowlValue = bowl.bowl?.value;
      if (bowlValue && typeof bowlValue === 'string' && bowlValue.length === 1) {
        const charCode = bowlValue.charCodeAt(0);
        if (charCode >= 65 && charCode <= 90) {
          if (charCode > maxBowlCharCode) {
            maxBowlCharCode = charCode;
          }
        }
      }
    });

    const nextNumericId = maxNumericId + 1; // 1, 2, 3, 4, etc.
    const nextAlphabeticValue = String.fromCharCode(maxBowlCharCode + 1); // A, B, C, D, etc.

    // Collect all field names from existing rows to ensure consistency
    const allFieldNames = new Set();
    newApiData.bowls.forEach(bowl => {
      if (bowl.rows && Array.isArray(bowl.rows)) {
        bowl.rows.forEach(row => {
          Object.keys(row).forEach(key => {
            if (key !== "row_id" && key !== "isNew" && typeof row[key] === "object" && "value" in row[key]) {
              allFieldNames.add(key);
            }
          });
        });
      }
    });

    // Create new row with all fields from existing rows, but with empty values
    const newRow = {
      row_id: 1
    };

    // Get a reference row to copy field structure from (use first row from first bowl if available)
    let referenceRow = null;
    if (newApiData.bowls.length > 0 && newApiData.bowls[0].rows && newApiData.bowls[0].rows.length > 0) {
      referenceRow = newApiData.bowls[0].rows[0];
    }

    // Add all fields with empty values, preserving structure from reference row
    allFieldNames.forEach(fieldName => {
      // Fields that should be mandatory even in new rows
      const mandatoryFieldsForNewRows = [
        'consumption_batch_number_sponsor',
        'consumption_batch_number',
        'actual_material_quantity_consumed'
      ];
      
      if (referenceRow && referenceRow[fieldName] && typeof referenceRow[fieldName] === "object") {
        // Copy structure from reference row but set value to empty
        // Remove isMandatory, reasonCode, and comment for new rows - they should not show mandatory indicator or info icon
        // EXCEPT for consumption_batch_number_sponsor, consumption_batch_number, and actual_material_quantity_consumed
        const { isMandatory, reasonCode, comment, ...fieldWithoutMandatory } = referenceRow[fieldName];
        
        // Check if field is visible on UI (true if undefined or explicitly true)
        const isFieldVisibleOnUI = referenceRow[fieldName].isVisibleOnUI !== false;
        const isMandatoryField = mandatoryFieldsForNewRows.includes(fieldName);
        
        // Only set needValidation and isMandatory for fields visible on UI
        if (isFieldVisibleOnUI) {
          // Set needValidation: true for visible fields (so edit icon appears)
          newRow[fieldName] = {
            ...fieldWithoutMandatory,
            value: "",
            confidence: "0",
            needValidation: true
          };
          // Set isMandatory for specific fields even in new rows (only if visible on UI)
          if (isMandatoryField) {
            newRow[fieldName].isMandatory = true;
          }
        } else {
          // For non-visible fields, don't set needValidation or isMandatory
          newRow[fieldName] = {
            ...fieldWithoutMandatory,
            value: "",
            confidence: "0"
          };
        }
        // Preserve isVisibleOnUI if it exists
        if (referenceRow[fieldName].isVisibleOnUI !== undefined) {
          newRow[fieldName].isVisibleOnUI = referenceRow[fieldName].isVisibleOnUI;
        }
        // Preserve dataType if it exists
        if (referenceRow[fieldName].dataType) {
          newRow[fieldName].dataType = referenceRow[fieldName].dataType;
        }
      } else {
        // Default structure if no reference row exists
        // Assume field is visible on UI if no reference row exists
        const isMandatoryField = mandatoryFieldsForNewRows.includes(fieldName);
        newRow[fieldName] = {
          confidence: "0",
          dataType: "String",
          needValidation: true, // Visible fields need edit icon
          value: "",
          isVisibleOnUI: true
        };
        // Set isMandatory for specific fields even in new rows (only for visible fields)
        if (isMandatoryField) {
          newRow[fieldName].isMandatory = true;
        }
      }
    });

    // If no existing fields found, create default fields
    if (allFieldNames.size === 0) {
      newRow.consumed_material_number_sponsor = {
        confidence: "0",
        dataType: "String",
        needValidation: false, // Not a mandatory field, no validation needed
        value: "",
        isVisibleOnUI: true
      };
      newRow.consumption_batch_number_sponsor = {
        confidence: "0",
        dataType: "String",
        needValidation: true, // Mandatory field, needs validation
        value: "",
        isMandatory: true, // Show mandatory star for consumption batch number
        isVisibleOnUI: true
      };
      newRow.actual_material_quantity_consumed = {
        confidence: "0",
        dataType: "Numeric",
        needValidation: true, // Mandatory field, needs validation
        value: "",
        isMandatory: true, // Show mandatory star for actual material quantity consumed
        isVisibleOnUI: true
      };
    }

    // Set isMandatory for consumption_batch_number_sponsor and actual_material_quantity_consumed
    // even if they were copied from reference row (for first material)
    // Only set if the field is visible on UI
    if (newRow.consumption_batch_number_sponsor && newRow.consumption_batch_number_sponsor.isVisibleOnUI !== false) {
      newRow.consumption_batch_number_sponsor.isMandatory = true;
      newRow.consumption_batch_number_sponsor.needValidation = newRow.consumption_batch_number_sponsor.needValidation !== false ? true : false;
    }
    // Also check for consumption_batch_number (without _sponsor suffix)
    if (newRow.consumption_batch_number && newRow.consumption_batch_number.isVisibleOnUI !== false) {
      newRow.consumption_batch_number.isMandatory = true;
      newRow.consumption_batch_number.needValidation = newRow.consumption_batch_number.needValidation !== false ? true : false;
    }
    if (newRow.actual_material_quantity_consumed && newRow.actual_material_quantity_consumed.isVisibleOnUI !== false) {
      newRow.actual_material_quantity_consumed.isMandatory = true;
      newRow.actual_material_quantity_consumed.needValidation = newRow.actual_material_quantity_consumed.needValidation !== false ? true : false;
    }

    const newBowl = {
      ID: nextNumericId, // Numeric ID: 1, 2, 3, 4, etc.
      isNew: true,
      bowl: { value: nextAlphabeticValue, confidence: "0", dataType: "String" }, // Alphabetic value: A, B, C, D, etc.
      rows: [newRow]
    };

    newApiData.bowls.push(newBowl);

    setApiData(newApiData);
    setEditedData(newApiData);
  };

  const renderBowls = (bowls) => {
    if (!bowls || !Array.isArray(bowls) || bowls.length === 0) return null;

    // Fields that should be numbered (batch-related fields)
    const numberedFields = [
      "consumption_batch_number",
      "consumption_batch_number_sponsor",
      "actual_material_quantity_consumed",
    ];

    return bowls.map((bowl, bowlIndex) => {
      const originalBowlIndex = bowlIndex;
      const toBeReviewed = apiData.noOfFieldsToBeReviewed || 0;
      const reviewed = apiData.noOfFieldsReviewed || 0;
      const isMarkedAsReviewed = apiData.markAsReviewed === true;
      const markAsCompleteVisible = !showingOriginal && (toBeReviewed > 0 || reviewed > 0) && !isMarkedAsReviewed;
      const noPartialShippingDetails = !batchDetails?.partialShippingDetails || batchDetails?.partialShippingDetails?.length === 0;
      
      const canShowDeleteActions = ((enableAllFieldsEdit) ||
        (markAsCompleteVisible) || (isMarkedAsReviewed && noPartialShippingDetails)) &&
      !showingOriginal && 
      !isEditingDisabled() && canReviewAndEdit();
      
      const showDeleteIconForBowl = bowlIndex > 0 && canShowDeleteActions;
      
      return (
      <Box key={bowl.ID} mt={3}>
        <Box display="flex" alignItems="center" mb={2}>
          <Typography variant="h6" className={classes.sectionTitle}>
            Consumption Details {bowl?.bowl?.value || bowl.ID}
          </Typography>
          {showDeleteIconForBowl && (
            <Box display="flex" alignItems="center" ml={1}>
              <IconButton
                disabled={isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()}
                onClick={() => {
                  if (!isEditingDisabled() && canReviewAndEdit() && isDocumentCategoryEditable()) {
                    handleDeleteConsumptionSectionClick(originalBowlIndex, false);
                  }
                }}
                style={{ 
                  color: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "red", 
                  padding: 6,
                  marginTop: 2,
                  cursor: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "not-allowed" : "pointer"
                }}
                size="small"
                title={(isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "Delete consumption section (disabled)" : "Delete consumption section"}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
        </Box>
        {bowl.rows && Array.isArray(bowl.rows) && bowl.rows.length > 0 ? bowl.rows.map((row, rowIndex) => {
          
          // Helper to get material number value from a row
          const getMaterialNumberValue = (row) => {
            return row.consumed_material_number_sponsor?.value || 
                   row.consumed_material_number?.value || 
                   null;
          };

          // Get current row's material number
          const currentMaterialNumber = getMaterialNumberValue(row);
          
          // Get previous row's material number (if not first row)
          const previousRow = rowIndex > 0 ? bowl.rows[rowIndex - 1] : null;
          const previousMaterialNumber = previousRow ? getMaterialNumberValue(previousRow) : null;
          
          // Check if material number matches previous row (skip material number fields if it matches)
          const shouldSkipMaterialNumber = rowIndex > 0 && currentMaterialNumber === previousMaterialNumber && currentMaterialNumber !== null;
          
          // Separate fields into numbered and non-numbered
          const rowFields = Object.keys(row).filter(
            (key) =>
              key !== "row_id" &&
              key !== "isNew" &&
              typeof row[key] === "object" &&
              "value" in row[key]
          );

          // Define field order for consistent display
          const materialFieldOrder = [
            "consumed_material_number",
            "consumed_material_number_sponsor",
            "consumed_material_uom",
          ];
          const batchFieldOrder = [
            "consumption_batch_number",
            "consumption_batch_number_sponsor",
            "actual_material_quantity_consumed",
          ];

          // Helper to check if a field is a batch field (base or with suffix)
          const isBatchFieldKey = (key) => {
            return numberedFields.some(baseField => {
              return key === baseField || key.startsWith(baseField + '_');
            });
          };
          
          const materialFields = rowFields
            .filter((key) => {
              // Filter out batch fields
              if (isBatchFieldKey(key)) return false;
              
              // For new consumed batches (rows after the first one), hide all material fields
              // Only show material fields for the first row (rowIndex === 0)
              if (rowIndex > 0) {
                return false;
              }
              
              // Skip material number fields if they match previous row
              if (shouldSkipMaterialNumber && (key === "consumed_material_number" || key === "consumed_material_number_sponsor")) {
                return false;
              }
              
              // Check isVisibleOnUI property
              const path = `bowls[${originalBowlIndex}].rows[${rowIndex}].${key}`;
              const dataForCheck = showingOriginal ? originalData : apiData;
              const fieldData = getNestedValue(dataForCheck, path);
              
              // If isVisibleOnUI is explicitly false, hide the field
              // If undefined or true, show it (backward compatibility)
              return fieldData?.isVisibleOnUI !== false;
            })
            .sort((a, b) => {
              const indexA = materialFieldOrder.indexOf(a);
              const indexB = materialFieldOrder.indexOf(b);
              if (indexA === -1 && indexB === -1) return 0;
              if (indexA === -1) return 1;
              if (indexB === -1) return -1;
              return indexA - indexB;
            });
          
          // Since one row = one batch, get batch fields directly from row
          const batchFields = rowFields.filter(key => isBatchFieldKey(key));

          return (
            <Box key={row.row_id} ml={2} mt={2}>
              {/* Material fields (displayed once, no numbering) */}
              {materialFields.map((fieldKey) => {
                const path = `bowls[${originalBowlIndex}].rows[${rowIndex}].${fieldKey}`;
                
                return (
                  <Grid
                    container
                    alignItems="center"
                    spacing={2}
                    className={classes.formField}
                    key={path}
                  >
                    <Grid item xs={4}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography
                          style={{ paddingRight: 16, fontWeight: 500 }}
                        >
                          {toTitleCase(fieldKey)}
                          {isFieldMandatory(path) && (
                            <span className={classes.requiredStar}>*</span>
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={8}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box style={{ width: "calc(100% - 70px)" }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={getValueForField(path)}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    pl={1}
                                  >
                                    <Box
                                      style={{
                                        width: 1,
                                        height: 39,
                                        backgroundColor: "#ccc",
                                        marginRight: 3,
                                      }}
                                    />
                                    {shouldShowInfoIcon(path) ? (
                                      <Box
                                        onClick={() =>
                                          fetchFieldHistory(
                                            path,
                                            toTitleCase(fieldKey)
                                          )
                                        }
                                        style={{
                                          backgroundColor: "#777",
                                          color: "white",
                                          borderRadius: 4,
                                          padding: "2px 8px",
                                          fontSize: "0.75rem",
                                          fontWeight: 600,
                                          minWidth: 24,
                                          textAlign: "center",
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Info fontSize="small" />
                                      </Box>
                                    ) : (
                                      <Box
                                        style={{
                                          backgroundColor: getLevelColor(
                                            getConfidenceForField(path)
                                          ),
                                          color: "white",
                                          borderRadius: 4,
                                          padding: "2px 8px",
                                          fontSize: "0.75rem",
                                          fontWeight: 600,
                                          minWidth: 24,
                                          textAlign: "center",
                                        }}
                                      >
                                        {getConfidenceDisplay(path)}
                                      </Box>
                                    )}
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                        <Box
                          style={{
                            width: 32,
                            height: 32,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {(() => {
                            const toBeReviewed = apiData.noOfFieldsToBeReviewed || 0;
                            const reviewed = apiData.noOfFieldsReviewed || 0;
                            const isMarkedAsReviewed = apiData.markAsReviewed === true;
                            const markAsCompleteVisible = !showingOriginal && (toBeReviewed > 0 || reviewed > 0) && !isMarkedAsReviewed;
                            const isCategoryEditable = isDocumentCategoryEditable();
                            
                            const shouldShowEdit = ((enableAllFieldsEdit ||
                              shouldShowEditForValidation(path)) ||
                              (markAsCompleteVisible && shouldShowInfoIcon(path)) || (isMarkedAsReviewed && noPartialShippingDetails && shouldShowInfoIcon(path))) &&
                            !showingOriginal && 
                            !isEditingDisabled() && canReviewAndEdit();
                            
                            return shouldShowEdit ? (
                              <Box
                                onClick={() => {
                                  if (isCategoryEditable) {
                                    handleOpenEditModal(
                                      path,
                                      toTitleCase(fieldKey)
                                    );
                                  }
                                }}
                                style={{
                                  cursor: isCategoryEditable ? "pointer" : "not-allowed",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  opacity: isCategoryEditable ? 1 : 0.5,
                                }}
                              >
                                <Edit
                                  fontSize="small"
                                  style={{ color: "#EC6535" }}
                                />
                              </Box>
                            ) : null;
                          })()}
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                );
              })}

              {/* Batch fields (one row = one batch) */}
              {(() => {
                // Filter and sort batch fields first
                const dataForCheck = showingOriginal ? originalData : apiData;
                const visibleBatchFields = batchFields
                  .filter(key => {
                    // Check isVisibleOnUI property
                    const fieldPath = `bowls[${originalBowlIndex}].rows[${rowIndex}].${key}`;
                    const fieldData = getNestedValue(dataForCheck, fieldPath);
                    
                    // If isVisibleOnUI is explicitly false, hide the field
                    return fieldData?.isVisibleOnUI !== false;
                  })
                  .sort((a, b) => {
                    // Sort using batchFieldOrder if defined
                    const indexA = batchFieldOrder.indexOf(a);
                    const indexB = batchFieldOrder.indexOf(b);
                    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                    if (indexA !== -1) return -1;
                    if (indexB !== -1) return 1;
                    return a.localeCompare(b);
                  });
                
                return visibleBatchFields.map((fieldKey, fieldIndex) => {
                  const path = `bowls[${originalBowlIndex}].rows[${rowIndex}].${fieldKey}`;
                  // Use actual field name from response and append sequential number (based on array position, not row_id)
                  const fieldLabel = `${toTitleCase(fieldKey)} ${rowIndex + 1}`;
                  // Show delete icon for rows except the first one (one row = one batch)
                  const showDeleteIcon = rowIndex > 0 && canShowDeleteActions;
                  
                  // Only show delete icon on the first batch field
                  const isFirstBatchField = fieldIndex === 0;
                  
                  return (
                    <Grid
                      container
                      alignItems="center"
                      spacing={2}
                      className={classes.formField}
                      key={path}
                    >
                      <Grid item xs={4}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Typography
                            style={{ paddingRight: 16, fontWeight: 500 }}
                          >
                            {fieldLabel}
                            {isFieldMandatory(path) && (
                              <span className={classes.requiredStar}>*</span>
                            )}
                          </Typography>
                          {showDeleteIcon && isFirstBatchField && (
                            <IconButton
                              disabled={isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()}
                              onClick={() => {
                                // Delete entire row (one row = one batch)
                                if (!isEditingDisabled() && canReviewAndEdit() && isDocumentCategoryEditable()) {
                                  handleDeleteBatchClick(originalBowlIndex, rowIndex, 1, fieldLabel, false);
                                }
                              }}
                              style={{ 
                                color: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "red", 
                                padding: 4,
                                cursor: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "not-allowed" : "pointer"
                              }}
                              title="Delete batch"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={8}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Box style={{ width: "calc(100% - 70px)" }}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              size="small"
                              value={getValueForField(path)}
                              InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      pl={1}
                                    >
                                      <Box
                                        style={{
                                          width: 1,
                                          height: 39,
                                          backgroundColor: "#ccc",
                                          marginRight: 3,
                                        }}
                                      />
                                      {shouldShowInfoIcon(path) ? (
                                        <Box
                                          onClick={() =>
                                            fetchFieldHistory(path, fieldLabel)
                                          }
                                          style={{
                                            backgroundColor: "#777",
                                            color: "white",
                                            borderRadius: 4,
                                            padding: "2px 8px",
                                            fontSize: "0.75rem",
                                            fontWeight: 600,
                                            minWidth: 24,
                                            textAlign: "center",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Info fontSize="small" />
                                        </Box>
                                      ) : (
                                        <Box
                                          style={{
                                            backgroundColor: getLevelColor(
                                              getConfidenceForField(path)
                                            ),
                                            color: "white",
                                            borderRadius: 4,
                                            padding: "2px 8px",
                                            fontSize: "0.75rem",
                                            fontWeight: 600,
                                            minWidth: 24,
                                            textAlign: "center",
                                          }}
                                        >
                                          {getConfidenceDisplay(path)}
                                        </Box>
                                      )}
                                    </Box>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box>
                          <Box
                            style={{
                              width: 32,
                              height: 32,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {(() => {
                            const toBeReviewed = apiData.noOfFieldsToBeReviewed || 0;
                            const reviewed = apiData.noOfFieldsReviewed || 0;
                            const isMarkedAsReviewed = apiData.markAsReviewed === true;
                            const markAsCompleteVisible = !showingOriginal && (toBeReviewed > 0 || reviewed > 0) && !isMarkedAsReviewed;
                            const isCategoryEditable = isDocumentCategoryEditable();
                            
                            const shouldShowEdit = ((enableAllFieldsEdit ||
                              shouldShowEditForValidation(path)) ||
                              (markAsCompleteVisible && shouldShowInfoIcon(path)) || (isMarkedAsReviewed && noPartialShippingDetails && shouldShowInfoIcon(path))) &&
                            !showingOriginal &&
                            !isEditingDisabled() && canReviewAndEdit();
                            
                            return shouldShowEdit ? (
                              <Box
                                onClick={() => {
                                  if (isCategoryEditable) {
                                    handleOpenEditModal(
                                      path,
                                      fieldLabel
                                    );
                                  }
                                }}
                                style={{
                                  cursor: isCategoryEditable ? "pointer" : "not-allowed",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  opacity: isCategoryEditable ? 1 : 0.5,
                                }}
                              >
                                <Edit
                                  fontSize="small"
                                  style={{ color: "#EC6535" }}
                                />
                              </Box>
                            ) : null;
                          })()}
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  );
                });
              })()}
            </Box>
          );
        }) : null}

        {/* Add New Consumed Batch button - below all rows for this consumption details section */}
        {(() => {
          const toBeReviewed = apiData.noOfFieldsToBeReviewed || 0;
          const reviewed = apiData.noOfFieldsReviewed || 0;
          const isMarkedAsReviewed = apiData.markAsReviewed === true;
          const markAsCompleteVisible = !showingOriginal && (toBeReviewed > 0 || reviewed > 0) && !isMarkedAsReviewed;
          const noPartialShippingDetails = !batchDetails?.partialShippingDetails || batchDetails?.partialShippingDetails?.length === 0;
          
          const shouldShowAddButtons = ((enableAllFieldsEdit) ||
            (markAsCompleteVisible) || (isMarkedAsReviewed && noPartialShippingDetails)) &&
          !showingOriginal && 
          !isEditingDisabled() && canReviewAndEdit();
          
          return shouldShowAddButtons ? (
          <Box mt={2} mb={2} display="flex" alignItems="center" justifyContent="space-between">
            <Box ml={2}>
              <Button
                variant="outlined"
                disabled={isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()}
                startIcon={
                  <Box
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: "50%",
                      backgroundColor: "whilte",
                      color: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black",
                      border: `1px solid ${(isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black"}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: 8,
                    }}
                  >
                    <AddIcon style={{ fontSize: 16, color: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black" }} />
                  </Box>
                }
                onClick={() => {
                  // Add new row (one row = one batch)
                  // rowIndex parameter is not used since we always add a new row at the end
                  if (!isEditingDisabled() && canReviewAndEdit() && isDocumentCategoryEditable()) {
                    handleAddNewConsumedBatch(originalBowlIndex, 0, false);
                  }
                }}
                style={{
                  textTransform: "none",
                  borderColor: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black",
                  color: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black",
                  borderRadius: 10,
                  minWidth: 200,
                  height: 36,
                  cursor: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "not-allowed" : "pointer",
                }}
              >
                Add New Consumed Batch
              </Button>
            </Box>
            {/* Add New Consumed Material button - only show for the last bowl, positioned at right corner */}
            {bowlIndex === bowls.length - 1 && (
              <Box mr={2}>
                <Button
                  variant="outlined"
                  disabled={isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()}
                  startIcon={
                    <Box
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        backgroundColor: "white",
                        color: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black",
                        border: `1px solid ${(isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black"}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 8,
                      }}
                    >
                      <AddIcon style={{ fontSize: 16, color: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black" }} />
                    </Box>
                  }
                  onClick={() => {
                    if (!isEditingDisabled() && canReviewAndEdit() && isDocumentCategoryEditable()) {
                      handleAddNewConsumedMaterial();
                    }
                  }}
                  style={{
                    textTransform: "none",
                    borderColor: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black",
                    color: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "#999" : "black",
                    borderRadius: 10,
                    cursor: (isEditingDisabled() || !canReviewAndEdit() || !isDocumentCategoryEditable()) ? "not-allowed" : "pointer",
                  }}
                >
                  Add New Consumed Material
                </Button>
              </Box>
            )}
          </Box>
        ) : null;
        })()}
      </Box>
      );
    });
  };

  const renderPallets = (pallets) => {
    if (!pallets || !Array.isArray(pallets) || pallets.length === 0) return null;

    return pallets.map((pallet, palletIndex) => {
      const palletNumber = pallet.row_id || palletIndex + 1;
      return (
        <Box key={palletIndex} mt={3}>
          <Typography variant="h6" className={classes.sectionTitle}>
            Pallet {palletNumber}
          </Typography>
          <Box ml={2} mt={2}>
            {Object.keys(pallet)
              .filter(
                (key) =>
                  key !== "row_id" &&
                  typeof pallet[key] === "object" &&
                  "value" in pallet[key]
              )
              .map((fieldKey) => {
                const path = `pallets[${palletIndex}].${fieldKey}`;
                return (
                  <Grid
                    container
                    alignItems="center"
                    spacing={2}
                    className={classes.formField}
                    key={path}
                  >
                    <Grid item xs={4}>
                      <Box display="flex" alignItems="center">
                        <Typography
                          style={{ paddingRight: 16, fontWeight: 500 }}
                        >
                          {toTitleCase(fieldKey)}
                          {isFieldMandatory(path) && (
                            <span className={classes.requiredStar}>*</span>
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={8}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box style={{ width: "calc(100% - 70px)" }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={getValueForField(path)}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    pl={1}
                                  >
                                    <Box
                                      style={{
                                        width: 1,
                                        height: 39,
                                        backgroundColor: "#ccc",
                                        marginRight: 3,
                                      }}
                                    />
                                    {shouldShowInfoIcon(path) ? (
                                      <Box
                                        onClick={() =>
                                          fetchFieldHistory(
                                            path,
                                            toTitleCase(fieldKey)
                                          )
                                        }
                                        style={{
                                          backgroundColor: "#777",
                                          color: "white",
                                          borderRadius: 4,
                                          padding: "2px 8px",
                                          fontSize: "0.75rem",
                                          fontWeight: 600,
                                          minWidth: 24,
                                          textAlign: "center",
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Info fontSize="small" />
                                      </Box>
                                    ) : (
                                      <Box
                                        style={{
                                          backgroundColor: getLevelColor(
                                            getConfidenceForField(path)
                                          ),
                                          color: "white",
                                          borderRadius: 4,
                                          padding: "2px 8px",
                                          fontSize: "0.75rem",
                                          fontWeight: 600,
                                          minWidth: 24,
                                          textAlign: "center",
                                        }}
                                      >
                                        {getConfidenceDisplay(path)}
                                      </Box>
                                    )}
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                        <Box
                          style={{
                            width: 32,
                            height: 32,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {(() => {
                            const toBeReviewed = apiData.noOfFieldsToBeReviewed || 0;
                            const reviewed = apiData.noOfFieldsReviewed || 0;
                            const isMarkedAsReviewed = apiData.markAsReviewed === true;
                            const markAsCompleteVisible = !showingOriginal && (toBeReviewed > 0 || reviewed > 0) && !isMarkedAsReviewed;
                            const isCategoryEditable = isDocumentCategoryEditable();
                            
                            const shouldShowEdit = ((enableAllFieldsEdit ||
                              shouldShowEditForValidation(path)) ||
                              (markAsCompleteVisible && shouldShowInfoIcon(path)) || (isMarkedAsReviewed && noPartialShippingDetails && shouldShowInfoIcon(path))) &&
                            !showingOriginal &&
                            !isEditingDisabled() && canReviewAndEdit();
                            
                            return shouldShowEdit ? (
                              <Box
                                onClick={() => {
                                  if (isCategoryEditable) {
                                    handleOpenEditModal(
                                      path,
                                      toTitleCase(fieldKey)
                                    );
                                  }
                                }}
                                style={{
                                  cursor: isCategoryEditable ? "pointer" : "not-allowed",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  opacity: isCategoryEditable ? 1 : 0.5,
                                }}
                              >
                                <Edit
                                  fontSize="small"
                                  style={{ color: "#EC6535" }}
                                />
                              </Box>
                            ) : null;
                          })()}
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                );
              })}
          </Box>
        </Box>
      );
    });
  };

   const isMarkedAsReviewed = apiData.markAsReviewed === true;
   const noPartialShippingDetails = !batchDetails?.partialShippingDetails || batchDetails?.partialShippingDetails?.length === 0;

  return (
    <Box className={classes.body}>
      {/* Loading overlays */}
      {isFetchingHistory && (
        <Box
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <Box
            style={{
              backgroundColor: "white",
              padding: 24,
              borderRadius: 8,
              textAlign: "center",
              minWidth: 200,
            }}
          >
            <CircularProgress size={40} style={{ marginBottom: 16 }} />
            <Typography variant="h6">Loading field history...</Typography>
          </Box>
        </Box>
      )}
      {isRefreshing && (
        <Box
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <Box
            style={{
              backgroundColor: "white",
              padding: 24,
              borderRadius: 8,
              textAlign: "center",
              minWidth: 200,
            }}
          >
            <CircularProgress size={40} style={{ marginBottom: 16 }} />
            <Typography variant="h6">Refreshing data...</Typography>
          </Box>
        </Box>
      )}

      <Grid container direction="column" spacing={2}>
        <Grid item container alignItems="center" spacing={2}>
          <Grid item>
            <Button
              startIcon={<ChevronLeft fontSize="small" />}
              style={{
                fontWeight: "bold",
                textTransform: "none",
                marginLeft: "0px",
              }}
              onClick={handleClose}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Typography variant="h6">
              Digitalized {(docType || "").replace(/\bOf\b/g, "of")}
            </Typography>
          </Grid>
        </Grid>

        <Grid item>
          <Divider
            style={{
              margin: "0px 0px 0px 0px",
              backgroundColor: "#707070",
              height: 1,
              zIndex: 4,
            }}
          />
        </Grid>

        <Grid style={{ marginTop: "1rem", marginBottom: "2rem" }}>
          {batchDetails && (
            <Box
              style={{
                backgroundColor: "#EAF4FB",
                borderRadius: 4,
                padding: "10px 16px",
              }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {["PO Number", "Sponsor Shipment ID", "FF Schedule ID", "CMO"].map((label) => (
                      <TableCell
                        key={label}
                        style={{
                          fontWeight: 700,
                          border: "none",
                          color: "#555",
                          padding: "4px 12px 2px 12px",
                          fontSize: "0.78rem",
                          background: "transparent",
                        }}
                      >
                        {label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell style={{ border: "none", padding: "2px 12px 6px 12px", verticalAlign: "top" }}>
                      {Array.isArray(batchDetails.batchesList) && batchDetails.batchesList.length > 0
                        ? batchDetails.batchesList
                            .map((b) => b.scheduleAgreementNumber)
                            .filter(Boolean)
                            .map((num, i) => <div key={i}>{num}</div>)
                        : "-"}
                    </TableCell>
                    <TableCell style={{ border: "none", padding: "2px 12px 6px 12px", verticalAlign: "top" }}>
                      {batchDetails.sponsorShipmentID || "-"}
                    </TableCell>
                    <TableCell style={{ border: "none", padding: "2px 12px 6px 12px", verticalAlign: "top" }}>
                      {batchDetails.freightForwarderScheduleID || "-"}
                    </TableCell>
                    <TableCell style={{ border: "none", padding: "2px 12px 6px 12px", verticalAlign: "top" }}>
                      {batchDetails.vendorName || "-"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          )}
        </Grid>

        <Grid item container alignItems="center" spacing={2}>
          <Grid item xs={6}>
            <Grid
              item
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              spacing={2}
            >
              <Typography
                variant="h6"
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  marginRight: "8px",
                }}
              >
                {(docType || "").replace(/\bOf\b/g, "of")} Data
              </Typography>
              <Box display="flex" gap={1} spacing={2}>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={() => {
                    if (showingOriginal) {
                      setApiData(editedData);
                      setShowingOriginal(false);
                    } else {
                      setApiData(originalData);
                      setShowingOriginal(true);
                    }
                  }}
                  style={{
                    marginRight: "8px",
                    minWidth: 20,
                    textAlign: "center",
                    size: "20px",
                    color: "white",
                    backgroundColor: "grey",
                    borderColor: "grey",
                  }}
                >
                  {showingOriginal
                    ? "Show Edited Version"
                    : "Show Unedited Version"}
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h6">
              {schrockenCustomFileID ? 
                (fileType === 'pdf' ? 'PDF Preview' : 
                 fileType === 'excel' ? 'Excel Preview' : 
                 'Loading Preview') : 
                'No Preview Available'}
            </Typography>
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "100%",
                padding: 16,
                overflowY: "auto",
              }}
            >
              {Object.keys(apiData)
                .filter(
                  (key) =>
                    key !== "bowls" &&
                    key !== "pallets" &&
                    typeof apiData[key] === "object" &&
                    "value" in apiData[key]
                )
                .map((fieldKey) => (
                  <Grid
                    container
                    alignItems="center"
                    spacing={2}
                    className={classes.formField}
                    key={fieldKey}
                  >
                    <Grid item xs={4}>
                      <Box display="flex" alignItems="center">
                        <Typography
                          style={{ paddingRight: 16, fontWeight: 500 }}
                        >
                          {toTitleCase(fieldKey)}
                          {isFieldMandatory(fieldKey) && (
                            <span className={classes.requiredStar}>*</span>
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={8}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box style={{ width: "calc(100% - 70px)" }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={getValueForField(fieldKey)}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    pl={1}
                                  >
                                    <Box
                                      style={{
                                        width: 1,
                                        height: 39,
                                        backgroundColor: "#ccc",
                                        marginRight: 3,
                                      }}
                                    />
                                    {shouldShowInfoIcon(fieldKey) ? (
                                      <Box
                                        onClick={() =>
                                          fetchFieldHistory(
                                            fieldKey,
                                            toTitleCase(fieldKey)
                                          )
                                        }
                                        style={{
                                          backgroundColor: "#777",
                                          color: "white",
                                          borderRadius: 4,
                                          padding: "2px 8px",
                                          fontSize: "0.75rem",
                                          fontWeight: 600,
                                          minWidth: 24,
                                          textAlign: "center",
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Info fontSize="small" />
                                      </Box>
                                    ) : (
                                      <Box
                                        style={{
                                          backgroundColor: getLevelColor(
                                            getConfidenceForField(fieldKey)
                                          ),
                                          color: "white",
                                          borderRadius: 4,
                                          padding: "2px 8px",
                                          fontSize: "0.75rem",
                                          fontWeight: 600,
                                          minWidth: 24,
                                          textAlign: "center",
                                        }}
                                      >
                                        {getConfidenceDisplay(fieldKey)}
                                      </Box>
                                    )}
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                        <Box
                          style={{
                            width: 32,
                            height: 32,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {(() => {
                            const toBeReviewed = apiData.noOfFieldsToBeReviewed || 0;
                            const reviewed = apiData.noOfFieldsReviewed || 0;
                            const isMarkedAsReviewed = apiData.markAsReviewed === true;
                            const markAsCompleteVisible = !showingOriginal && (toBeReviewed > 0 || reviewed > 0) && !isMarkedAsReviewed;
                            const isCategoryEditable = isDocumentCategoryEditable();
                            
                            const shouldShowEdit = ((enableAllFieldsEdit ||
                              shouldShowEditForValidation(fieldKey)) ||
                              (markAsCompleteVisible && shouldShowInfoIcon(fieldKey)) || (isMarkedAsReviewed && noPartialShippingDetails && shouldShowInfoIcon(fieldKey))) &&
                            !showingOriginal &&
                            !isEditingDisabled() && canReviewAndEdit();
                            
                            return shouldShowEdit ? (
                              <Box
                                onClick={() => {
                                  if (isCategoryEditable) {
                                    handleOpenEditModal(
                                      fieldKey,
                                      toTitleCase(fieldKey)
                                    );
                                  }
                                }}
                                style={{
                                  cursor: isCategoryEditable ? "pointer" : "not-allowed",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  opacity: isCategoryEditable ? 1 : 0.5,
                                }}
                              >
                                <Edit
                                  fontSize="small"
                                  style={{ color: "#EC6535" }}
                                />
                              </Box>
                            ) : null;
                          })()}
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                ))}

              {apiData.bowls && renderBowls(apiData.bowls)}

              {/* BCM-348: show validation errors below consumed batches */}
              {markReviewValidationErrors.length > 0 && (
                <Box mt={2} mb={2}>
                  {markReviewValidationErrors.map((err, index) => (
                    <Box
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 8,
                        marginBottom: 8,
                        padding: "10px 14px",
                        backgroundColor: "#f8d7da",
                        border: "1px solid #f44336",
                        borderRadius: 4,
                        color: "#b71c1c",
                      }}
                    >
                      <span style={{ fontSize: 16, marginTop: 1, color: "#f44336" }}>&#9888;</span>
                      <Typography variant="body2" style={{ color: "#b71c1c", fontWeight: 500 }}>
                        {err.errorMessage}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
              {apiData.pallets && renderPallets(apiData.pallets)}

              <Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:
                </Typography>
                <Grid item style={{ width: "28px" }} />
                {(() => {
                  const confidenceLevels = batchDetails?.confidenceLevels || {
                    lowConfidenceLimit: 80,
                    highConfidenceLimit: 90,
                  };
                  const lowConfidenceLimit =
                    confidenceLevels.lowConfidenceLimit;
                  const highConfidenceLimit =
                    confidenceLevels.highConfidenceLimit;
                  return (
                    <>
                      <Box
                        style={{
                          backgroundColor: "green",
                          color: "white",
                          borderRadius: 4,
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: 30,
                        }}
                      >
                        &gt; {highConfidenceLimit}
                      </Box>
                      <Box
                        style={{
                          backgroundColor: "orange",
                          color: "white",
                          borderRadius: 4,
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: 50,
                          marginLeft: 16,
                        }}
                      >
                        {confidenceLevels.mediumConfidenceLimitMinValue ||
                          lowConfidenceLimit}{" "}
                        -{" "}
                        {confidenceLevels.mediumConfidenceLimitMaxValue ||
                          highConfidenceLimit}
                      </Box>
                      <Box
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          borderRadius: 4,
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: 30,
                          marginLeft: 16,
                        }}
                      >
                        &lt; {lowConfidenceLimit}
                      </Box>
                    </>
                  );
                })()}
              </Box>

              {(() => {
                const isDocumentMarkedAsReviewed = apiData.markAsReviewed === true;
                const hasNoPartialShipping = !batchDetails?.partialShippingDetails || batchDetails?.partialShippingDetails?.length === 0;
                
                return !showingOriginal && (canReviewAndEdit() || (canReviewAndEdit() && (isDocumentMarkedAsReviewed && hasNoPartialShipping))) && (
                <Box
                  style={{
                    border: "1px solid #ddd",
                    padding: "12px",
                    borderRadius: "4px",
                    backgroundColor: "#f9f9f9",
                    marginTop: 32,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={enableAllFieldsEdit}
                        onChange={(e) =>
                          setEnableAllFieldsEdit(e.target.checked)
                        }
                        color="primary"
                        disabled={isEditingDisabled() || !isDocumentCategoryEditable()}
                      />
                    }
                    label="Apply edit feature to all the fields"
                  />
                  <Typography
                    variant="body2"
                    style={{
                      fontStyle: "italic",
                      color: (isEditingDisabled() || !isDocumentCategoryEditable()) ? "#999" : "#666",
                      marginTop: "4px",
                    }}
                  >
                    {/* <FormControlLabel
                      control={
                        <Checkbox
                          checked={enableAllFieldsEdit}
                          onChange={(e) =>
                            setEnableAllFieldsEdit(e.target.checked)
                          }
                          color="primary"
                          disabled={isEditingDisabled()}
                        />
                      }
                      label="Apply edit feature to all the fields"
                    />
                    <Typography
                      variant="body2"
                      style={{
                        fontStyle: "italic",
                        color: (isEditingDisabled()) ? "#999" : "#666",
                        marginTop: "4px",
                      }}
                    > */}
                      {(isEditingDisabled()) 
                        ? "No fields require review - all fields have acceptable confidence levels."
                        : "Note - This will enable editing of the high confidence level fields, highlighted in green colors."}
                    </Typography>
                  </Box>
                );
              })()}

              {(() => {
                const toBeReviewed = apiData.noOfFieldsToBeReviewed || 0;
                const reviewed = apiData.noOfFieldsReviewed || 0;
                const isMarkedAsReviewed = apiData.markAsReviewed === true;
                const hasPartialShippingDetails = batchDetails?.partialShippingDetails?.length > 0;
                const showMarkReviewButton = !showingOriginal && (toBeReviewed > 0 || reviewed > 0) && !isMarkedAsReviewed && canReviewAndEdit();
                const isCategoryEditable = isDocumentCategoryEditable();
                return (
                  <>
                    {showMarkReviewButton && <Box
                          style={{
                            marginTop: 64,
                            paddingBottom: 16,
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={!isCategoryEditable || (apiData.noOfFieldsToBeReviewed && apiData.noOfFieldsToBeReviewed > 0) || markingReviewComplete}
                            onClick={() => handleReviewAction(false)}
                            style={{
                              borderRadius: 30,
                              paddingLeft: "40px",
                              paddingRight: "40px",
                              textTransform: "none",
                              fontWeight: 500,
                            }}
                            endIcon={
                              markingReviewComplete ? (
                                <CircularProgress size={20} style={{ color: "white" }} />
                              ) : null
                            }
                          >
                            {markingReviewComplete ? "Processing..." : "Mark Review as Complete"}
                          </Button>

                        </Box>}

                    { isMarkedAsReviewed && batchDetails?.partialShippingDetails?.length === 0 && canReviewAndEdit() && <Box
                          style={{
                            marginTop: 64,
                            paddingBottom: 16,
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={!(reviewed > 0) || hasPartialShippingDetails || markingReviewComplete || !isCategoryEditable}
                            onClick={() => handleReviewAction(true)}
                            style={{
                              borderRadius: 30,
                              paddingLeft: "20px",
                              paddingRight: "20px",
                              textTransform: "none",
                              fontWeight: 500,
                            }}
                            endIcon={
                              markingReviewComplete ? (
                                <CircularProgress size={20} style={{ color: "white" }} />
                              ) : null
                            }
                          >
                            {markingReviewComplete ? "Processing..." : "Update values and reinitiate process flow changes"}
                          </Button>
                        </Box>}
                  </>
                );
              })()}
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                // height: "calc(100vh - 200px)",
                padding: 16,
                height: "100%",
                // overflow: "hidden",
              }}
            >
              <Box
                style={{
                  // height: 500,
                  // backgroundColor: "#f5f5f5",
                  // border: "1px dashed #ccc",
                }}
              >
                {schrockenCustomFileID ? (
                  <PDFViewer 
                    schrockenCustomFileID={schrockenCustomFileID}
                    onFileTypeChange={handleFileTypeChange}
                  />
                ) : (
                  <Box
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography>No PDF available</Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>

        {/* WIP Product Note - shown after update button for documents with consumption details */}
        {batchDetails?.cmoWIPProductCode && apiData?.bowls && Array.isArray(apiData.bowls) && apiData.bowls.length > 0 && (
          <Grid item xs={12}>
            <Box
              style={{
                border: "1px solid #000",
                padding: "12px 16px",
                margin: "40px 0",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="body2"
                style={{
                  fontWeight: 500,
                }}
              >
                Note - Product {productCode} might have WIP products. Please review the document carefully.
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>

      {/* History Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>
          <Box style={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table
              style={{
                border: "1.5px solid grey",
                borderCollapse: "collapse",
                width: "100%",
              }}
            >
              <TableHead style={{ backgroundColor: "#F5F5F5" }}>
                <TableRow>
                  <TableCell className={classes.FeildHistoryHorizantalBorder}>
                    Timestamp
                  </TableCell>
                  <TableCell className={classes.FeildHistoryHorizantalBorder}>
                    Before Value
                  </TableCell>
                  <TableCell className={classes.FeildHistoryHorizantalBorder}>
                    After Value
                  </TableCell>
                  <TableCell className={classes.FeildHistoryHorizantalBorder}>
                    Updated By
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {modalData.hasHistory ? (
                  modalData.historyData.map((record, index) => (
                    <TableRow key={index}>
                      <TableCell
                        className={classes.FeildHistoryHorizantalBorder}
                      >
                        {record.timestamp}
                      </TableCell>
                      <TableCell
                        className={classes.FeildHistoryHorizantalBorder}
                      >
                        {record.before}
                      </TableCell>
                      <TableCell
                        className={classes.FeildHistoryHorizantalBorder}
                      >
                        {record.after}
                      </TableCell>
                      <TableCell
                        className={classes.FeildHistoryHorizantalBorder}
                      >
                        {record.updatedBy}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={4}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No history found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
              style={{
                borderRadius: 30,
                paddingLeft: "40px",
                paddingRight: "40px",
              }}
              endIcon={<ArrowForwardIos style={{ fontSize: 15 }} />}
            >
              Ok
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Edit Modal */}
      <Modal open={openEditModal} onClose={() => setOpenEditModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6">
              Edit {editModalData.fieldLabel} for PO {poNumber || ""}
            </Typography>
            <Button
              onClick={() => setOpenEditModal(false)}
              style={{ minWidth: "auto" }}
            >
              ✕
            </Button>
          </Box>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Typography
                variant="body2"
                gutterBottom
                style={{ fontWeight: "bold" }}
              >
                {editModalData.fieldLabel}
              </Typography>
              <Box display="flex" alignItems="center">
                {editModalData.dataType === "Date" ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={editModalData.currentValue || ""}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    <Box
                      style={{
                        width: 32,
                        height: 32,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => setDatePickerOpen(true)}
                    >
                      <Event style={{ color: "#EC6535" }} />
                    </Box>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <DatePicker
                        open={datePickerOpen}
                        onClose={() => setDatePickerOpen(false)}
                        value={
                          editModalData.currentValue &&
                          editModalData.currentValue !== "n/a" &&
                          editModalData.currentValue !== "NA" &&
                          editModalData.currentValue !== "" &&
                          moment(editModalData.currentValue).isValid()
                            ? new Date(editModalData.currentValue)
                            : null
                        }
                        onChange={(date) => {
                          if (date && date.isValid()) {
                            const displayDate = date.format("DD-MMM-YYYY"); // UI format
                            const saveDate = convertToISOUTC(date.toDate()); // ISO UTC
                            setEditModalData((prev) => ({
                              ...prev,
                              currentValue: displayDate, // for showing in textfield
                              saveValue: saveDate, // for saving to backend
                            }));
                            // Clear error message when user selects a date
                            if (editModalValidationError) {
                              setEditModalValidationError("");
                            }
                          }
                          setDatePickerOpen(false);
                        }}
                        format="DD-MM-YYYY"
                        autoOk={true}
                        variant="dialog"
                        style={{ display: "none" }}
                        disableFuture={
                          (editModalData.fieldLabel || "")
                            .toString()
                            .trim()
                            .toLowerCase() === "date of manufacture"
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </Box>
                ) : (
                  // Your existing TextField code
                  <TextField
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={editModalData.currentValue}
                    onInput={(e) =>
                      handleInputRestriction(e, editModalData.dataType)
                    }
                    onBlur={(e) => {
                      const { value } = e.target;
                      // Trim leading and trailing spaces for string values
                      if (
                        typeof value === "string" &&
                        value.trim() !== value
                      ) {
                        const trimmedValue = value.trim();
                        setEditModalData((prev) => ({
                          ...prev,
                          currentValue: trimmedValue,
                        }));
                      }
                    }}
                    helperText={
                      editModalData.dataType === "Numeric"
                        ? "Only numbers and decimals are allowed"
                        : editModalData.dataType === "Numeric/Whole Number"
                        ? "Only whole numbers are allowed"
                        : editModalData.dataType === "String"
                        ? "Alphanumeric, spaces, . and - only allowed"
                        : ""
                    }
                  />
                )}
                {(editModalData.confidenceLevel !== null &&
                  editModalData.confidenceLevel > 90) ||
                shouldShowInfoIcon(editModalData.fieldKey) ? null : (
                  <Box
                    onClick={() => {
                      if (
                        editModalData.currentValue ===
                        editModalData.originalValue
                      ) {
                        setEditModalData((prev) => ({
                          ...prev,
                          digitalizationCode: "DG001",
                        }));
                      }
                    }}
                    style={{
                      backgroundColor:
                        editModalData.currentValue ===
                        editModalData.originalValue
                          ? "green"
                          : "#cccccc",
                      color: "white",
                      borderRadius: 4,
                      padding: "2px 8px",
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      minWidth: 24,
                      textAlign: "center",
                      cursor:
                        editModalData.currentValue ===
                        editModalData.originalValue
                          ? "pointer"
                          : "not-allowed",
                      opacity:
                        editModalData.currentValue ===
                        editModalData.originalValue
                          ? 1
                          : 0.5,
                      marginLeft: 8,
                      alignSelf: "flex-start",
                      marginTop: 9,
                    }}
                  >
                    ✓
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="body2"
                gutterBottom
                style={{ fontWeight: "bold" }}
              >
                Confidence Level (%)
              </Typography>
              <Typography variant="body2">
                {editModalData.confidenceLevel !== null
                  ? Math.round(editModalData.confidenceLevel)
                  : "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body2"
                gutterBottom
                style={{ fontWeight: "bold" }}
              >
                Digitalization Code / Description
              </Typography>
              <FormControl fullWidth variant="outlined" size="small">
                <Select
                  value={editModalData.digitalizationCode}
                  onChange={(e) => {
                    setEditModalData((prev) => ({
                      ...prev,
                      digitalizationCode: e.target.value,
                    }));
                    // Clear error if digitalization code is selected OR if comment has content
                    if (e.target.value || editModalData.comment.trim()) {
                      setEditModalValidationError("");
                    }
                  }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Select a digitalization code</em>
                  </MenuItem>
                  {apiDigitalizationCodes.map((code) => (
                    <MenuItem key={code.code} value={code.code}>
                      {code.code} / {code.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body2"
                gutterBottom
                style={{ fontWeight: "bold" }}
              >
                Comment
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                placeholder="Enter text here"
                value={editModalData.comment}
                onChange={(e) => {
                  if(e.target.value.length < 256){
                    setEditModalData((prev) => ({
                      ...prev,
                      comment: e.target.value,
                    }));
                    // Only clear error if user is typing (has content) or if digitalization code exists
                    if (e.target.value.trim() || editModalData.digitalizationCode) {
                      setEditModalValidationError("");
                    }
                  }
                }}
                onBlur={(e) => {
                  // Trim leading and trailing spaces on blur for better optimization
                  const trimmedValue = typeof e.target.value === 'string' ? e.target.value.trim() : e.target.value;
                  setEditModalData((prev) => ({
                    ...prev,
                    comment: trimmedValue,
                  }));
                  
                  // Validate on blur: if no digitalization code and no comment, show error
                  if (!editModalData.digitalizationCode && !trimmedValue) {
                    setEditModalValidationError(
                      "If digitalization code is not entered, comment field is mandatory"
                    );
                  }
                }}
                multiline
                rows={3}
                error={!!editModalValidationError}
              />
              <Typography
                variant="caption"
                color="textSecondary"
                style={{ marginTop: 4, display: 'block' }}
              >
                Note - If digitalization code is not entered, comment field is mandatory
              </Typography>
            </Grid>
            {/* Error message display - more prominent */}
            {editModalValidationError && (
              <Grid item xs={12}>
                <Box
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#ffebee",
                    border: "1px solid #f44336",
                    borderRadius: 4,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                  }}
                >
                  <WarningIcon style={{ color: '#f44336', fontSize: 20 }} />
                  <Typography
                    variant="body2"
                    color="error"
                    style={{ fontWeight: 500 }}
                  >
                    {editModalValidationError}
                  </Typography>
                </Box>
              </Grid>
            )}
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center">
                <Button
                  variant="contained"
                  style={{ borderRadius: 30 }}
                  color="primary"
                  onClick={handleSaveFieldEdit}
                  disabled={saving}
                  endIcon={
                    saving ? (
                      <CircularProgress size={20} />
                    ) : (
                      <ArrowForwardIos style={{ fontSize: 15 }} />
                    )
                  }
                >
                  {saving ? "Saving..." : "Save changes"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {/* Exit Warning Dialog */}
      <Dialog
        open={showExitWarning}
        onClose={() => setShowExitWarning(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle disableTypography style={{ padding: '16px 24px 0' }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={10}>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="body2"
                onClick={() => setShowExitWarning(false)}
                className={classes.closeText}
              >
                Cancel <CloseIcon fontSize="large" color="error" className={classes.icon} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ padding: '0px 40px 30px 40px', textAlign: 'center' }}>
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "center", marginBottom: '16px' }}
          >
            <WarningIcon
              style={{
                fontSize: "5rem",
                color: "#F00",
              }}
            />
          </Grid>
          <Typography variant="h6" style={{ marginBottom: '16px', fontWeight: 600 }}>
            Are you sure you want to exit?
          </Typography>
          <Typography variant="body1">
            You have not marked the review as complete.<br/> Process flow change is not initiated.
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', paddingBottom: '34px' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setShowExitWarning(false);
              onClose();
            }}
            style={{ minWidth: '150px', borderRadius: 30, textTransform: 'capitalize' }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success Dialog */}
      <Dialog
        open={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent style={{ padding: '30px 40px 20px 40px', textAlign: 'center' }}>
          <CheckCircleIcon style={{ fontSize: 60, color: '#2e7d32', marginBottom: '16px' }} />
          <Typography variant="h6" style={{ marginBottom: '16px', fontWeight: 600 }}>
            {successDialogTitle || "Updated Successfully"}
            {/* Updated Successfully */}
          </Typography>
          <Typography variant="body1">
            {successMessage}
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', paddingBottom: '30px' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setShowSuccessDialog(false);
              if (successMessage === "Process flow change is initiated." || 
                  successMessage === "Process flow changes have been reinitiated.") {
                onClose();
              }
            }}
            style={{ minWidth: '120px', borderRadius: 30, textTransform: 'capitalize' }}
            // onClick={() => setShowSuccessDialog(false)}
            // style={{ minWidth: '120px' }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={showDeleteConfirmDialog}
        onClose={() => {
          setShowDeleteConfirmDialog(false);
          setDeleteError("");
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 14,
          },
        }}
      >
        <DialogTitle style={{ padding: '12px 24px 0 24px', position: 'relative' }}>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setShowDeleteConfirmDialog(false);
              setDeleteError("");
            }}
          >
            <Typography
              variant="body2"
              style={{
                fontSize: '1rem',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                marginRight: '8px',
              }}
            >
              Cancel
            </Typography>
            <CloseIcon
              style={{
                fontSize: '35px',
                color: '#FF0000',
                cursor: 'pointer',
              }}
              onClick={() => {
                setShowDeleteConfirmDialog(false);
                setDeleteError("");
              }}
            />
          </Box>
        </DialogTitle>
        <DialogContent style={{ padding: '0px 24px 24px 24px', textAlign: 'center' }}>
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '32px',
            }}
          >
            <WarningIcon 
              style={{ 
                fontSize: '5rem',
                color: 'red',
              }} 
            />
          </Box>
          <Typography variant="h6" style={{ marginBottom: '16px', fontWeight: 600, whiteSpace: 'pre-line' }}>
            {deleteConfirmData.type === "batch" 
              ? "Are you sure you want to delete this batch?"
              : "Are you sure you want to delete the \nspecific consumption details?"}
          </Typography>
          {deleteConfirmData.type === "batch" ? (
            <Box style={{ marginBottom: '16px' }}>
              <Typography variant="body2" style={{ color: '#666', marginBottom: '8px' }}>
                <strong>Consumed Material Number BMS:</strong> {deleteConfirmData.materialNumber || "N/A"}
              </Typography>
              <Typography variant="body2" style={{ color: '#666', marginBottom: '4px' }}>
                <strong>Batch Number:</strong> {deleteConfirmData.batchNumberValue || "N/A"}
              </Typography>
            </Box>
          ) : (
            <Typography variant="body1" style={{ color: '#666', marginBottom: '8px' }}>
              {deleteConfirmData.consumptionDetailsLabel}
            </Typography>
          )}
          {deleteError && (
            <Box
              style={{
                marginTop: 16,
                padding: "12px 16px",
                backgroundColor: "#ffebee",
                border: "1px solid #f44336",
                borderRadius: 4,
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <WarningIcon style={{ color: '#f44336', fontSize: 20 }} />
              <Typography
                variant="body2"
                color="error"
                style={{ fontWeight: 500 }}
              >
                {deleteError}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', paddingBottom: '24px', paddingTop: '0' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirmDelete}
            disabled={saving}
            style={{ 
              minWidth: '150px',
              borderRadius: 30,
              paddingLeft: '20px',
              paddingRight: '20px',
              marginBottom: '10px',
              textTransform: 'none',
            }}
            endIcon={saving ? <CircularProgress size={20} /> : null}
          >
            {saving ? "Deleting..." : "Confirm Deletion"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Material Number Validation Error Dialog */}
      <Dialog
        open={showMaterialNumberError}
        onClose={() => setShowMaterialNumberError(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 14,
          },
        }}
      >
        <DialogTitle style={{ padding: '12px 24px 0 24px', position: 'relative' }}>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowMaterialNumberError(false)}
          >
            <Typography
              variant="body2"
              style={{
                fontSize: '1rem',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                marginRight: '8px',
              }}
            >
              Close
            </Typography>
            <CloseIcon
              style={{
                fontSize: '35px',
                color: '#FF0000',
                cursor: 'pointer',
              }}
              onClick={() => setShowMaterialNumberError(false)}
            />
          </Box>
        </DialogTitle>
        <DialogContent style={{ padding: '0px 24px 24px 24px', textAlign: 'center' }}>
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '32px',
            }}
          >
            <WarningIcon 
              style={{ 
                fontSize: '5rem',
                color: '#FF9800',
              }} 
            />
          </Box>
          <Typography variant="h6" style={{ marginBottom: '16px', fontWeight: 600 }}>
            Consumed Material Number Required
          </Typography>
          <Typography variant="body1" style={{ color: '#666', marginBottom: '8px' }}>
            Please enter the Consumed Material Number first before adding or editing consumed batch details.
          </Typography>
          <Typography variant="body2" style={{ color: '#999', marginTop: '12px', fontStyle: 'italic' }}>
            The material number must be filled in before you can add or edit batch information for that material.
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', paddingBottom: '24px', paddingTop: '0' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setShowMaterialNumberError(false)}
            style={{ 
              minWidth: '120px',
              borderRadius: 30,
              paddingLeft: '20px',
              paddingRight: '20px',
              marginBottom: '10px',
              textTransform: 'none',
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CommonDigitizedDocument;